import { t as we } from "./module.esm-CPdxcUov.js";
import { n as Sn, t as he } from "./morphNodes-BUJqEfyn.js";
import { t as Tn } from "./queueBounce-CVV88D_L.js";
import { t as kn } from "./searchStore-Bc6byiKr.js";
var Cn = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, Bt = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, Nn = (e) => e.data("addressSwitch", ({ addresses: t }) => ({
  addresses: t,
  slideTransition: Bt,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(n) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((r) => r.id === n), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), On = (e) => e.data("announcement", (t) => {
  const { settings: n } = t;
  return {
    current: 0,
    init() {
      n.auto_scroll && t.count > 0 && this.autoScroll(), this.$watch("current", (r) => this.autoScroll(r));
    },
    change(r) {
      this.current = r;
    },
    autoScroll(r = 0) {
      r >= t.count ? r = 0 : r += 1, setTimeout(() => this.change(r), n.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), In = (e) => {
  e.data("backInStock", (t, n) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: n,
      product: t,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const r = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", i = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const a = await fetch(r, i);
        if (!a.ok) throw new Error("Failed to subscribe");
        if (!(await a.json()).success) throw new Error("Failed to subscribe");
      } catch (a) {
        console.error(a);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, _n = (e) => {
  e.data("cardBadges", (t) => ({
    product: t,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(n) {
      const r = this.product.additional_data || {};
      for (const i of n.keys || []) {
        const a = r[i], o = Array.isArray(a) ? a.find((s) => String(s).trim() !== "") : a;
        if (o != null && String(o).trim() !== "") return String(o).trim();
      }
      return "";
    },
    badgeLabel(n) {
      if (n.kind === "tag") return (this.product.tags || []).map((i) => String(i).trim().toLowerCase()).includes(n.tag) ? n.label : null;
      if (n.kind === "sold_out") return this.product.available === !1 ? n.label : null;
      const r = this.badgeFieldValue(n);
      return r === "" || r === "false" || r === "0" ? null : n.kind === "metafield_text" ? r : n.label;
    },
    resolveBadge() {
      for (const n of this.badgeRules) {
        const r = this.badgeLabel(n);
        if (r) return {
          ...n,
          label: r
        };
      }
      return null;
    }
  }));
}, Ln = (e) => {
  const t = {
    id: Number(e.get("id")),
    quantity: Number(e.get("quantity") ?? 1),
    properties: {}
  };
  for (const [n, r] of e.entries())
    if (n === "selling_plan" && r && (t.selling_plan = Number(r)), n.startsWith("properties")) {
      const i = n.match(/\[(.*)\]/)?.[1];
      i && (t.properties[i] = String(r).replace("Offset ", ""));
    }
  return t;
}, xe = /* @__PURE__ */ (function(e) {
  return e.ADD = "cart/add.js", e.CHANGE = "cart/change.js", e.CLEAR = "cart/clear.js", e.UPDATE = "cart/update.js", e.GET = "cart.js", e;
})({}), oe = (e, t) => t instanceof e ? t : null, Fn = (e, t, n = 0) => Math.min(Math.max(e, n), t), Se = {}, Rn = async (e) => {
  const t = e.toString();
  if (Se[t]) return Se[t];
  const n = await fetch(e);
  return n.ok ? (Se[t] = await n.text(), Se[t]) : null;
}, An = () => new Promise((e) => queueMicrotask(() => setTimeout(e, 0))), Dn = (e, t, n = 0) => (e - n) % (t - n) + n, Ht = class Vt {
  val;
  constructor(t) {
    this.val = t;
  }
  isSome() {
    return !0;
  }
  isNone() {
    return !1;
  }
  unwrap() {
    return this.val;
  }
  unwrapOr(t) {
    return this.val;
  }
  unwrapOrElse(t) {
    return this.val;
  }
  expect(t) {
    return this.val;
  }
  andThen(t) {
    return t(this.val);
  }
  orElse() {
    return this;
  }
  map(t) {
    return new Vt(t(this.val));
  }
  mapOr(t, n) {
    return t(this.val);
  }
  mapOrElse(t, n) {
    return t(this.val);
  }
  flatten() {
    return $n(this.val) ? this.val : this;
  }
  inspect(t) {
    return t === 2 ? this : (t(this.val), this);
  }
  okOr(t) {
    return new et(this.val);
  }
}, qt = class {
  val = null;
  isSome() {
    return !1;
  }
  isNone() {
    return !0;
  }
  unwrap() {
    throw new Error("called `Option.unwrap()` on a `None` value");
  }
  unwrapOr(e) {
    return e;
  }
  unwrapOrElse(e) {
    return e();
  }
  expect(e) {
    throw new Error(`Error unwrapping None. Expected ${e}`);
  }
  andThen() {
    return this;
  }
  orElse(e) {
    return e();
  }
  map(e) {
    return this;
  }
  mapOr(e, t) {
    return t;
  }
  mapOrElse(e, t) {
    return t();
  }
  flatten() {
    return this;
  }
  inspect() {
    return this;
  }
  okOr(e) {
    return new Le(e);
  }
}, $n = (e) => e instanceof Ht || e instanceof qt, Mn = new qt(), Pn = /* @__PURE__ */ Symbol(), jn = /* @__PURE__ */ Symbol(), et = class Ut {
  is = Pn;
  value;
  constructor(t) {
    this.value = t;
  }
  isOk() {
    return !0;
  }
  isErr() {
    return !1;
  }
  unwrap() {
    return this.value;
  }
  unwrapOr(t) {
    return this.value;
  }
  unwrapOrElse(t) {
    return this.value;
  }
  unwrapErr() {
    throw new Error("called `Result.unwrapErr()` on an `Ok` value");
  }
  expect(t) {
    return this.value;
  }
  andThen(t) {
    return t(this.value);
  }
  orElse() {
    return this;
  }
  map(t) {
    return new Ut(t(this.value));
  }
  mapErr() {
    return this;
  }
  mapOr(t, n) {
    return t(this.value);
  }
  mapOrElse(t, n) {
    return t(this.value);
  }
  inspect(t) {
    return t === 2 ? this.value : (t(this.value), this);
  }
  inspectErr() {
    return this;
  }
  ok() {
    return new Ht(this.value);
  }
  flatten() {
    const t = this.value;
    return Bn(t) ? t : this;
  }
}, Le = class Wt {
  is = jn;
  error;
  constructor(t) {
    this.error = t;
  }
  isOk() {
    return !1;
  }
  isErr() {
    return !0;
  }
  unwrap() {
    throw this.error;
  }
  unwrapOr(t) {
    return t;
  }
  unwrapOrElse(t) {
    return t(this.error);
  }
  unwrapErr() {
    return this.error;
  }
  expect(t) {
    throw new Error(`Error unwrapping Err value: ${this.error}. Expected ${t}`);
  }
  andThen() {
    return this;
  }
  orElse(t) {
    return t(this.error);
  }
  map() {
    return this;
  }
  mapErr(t) {
    return new Wt(t(this.error));
  }
  mapOr(t, n) {
    return n;
  }
  mapOrElse(t, n) {
    return n(this.error);
  }
  inspect(t) {
    return t === 2 ? this.error : this;
  }
  inspectErr(t) {
    return t(this.error), this;
  }
  ok() {
    return Mn;
  }
  flatten() {
    return this;
  }
}, Bn = (e) => e instanceof et || e instanceof Le, ct = class extends Error {
  retry = !1;
  fullPull = !1;
  constructor(e) {
    super(e.message, { cause: e }), e.status === zt.UnprocessableEntity && (this.fullPull = !0);
  }
}, zt = /* @__PURE__ */ (function(e) {
  return e[e.Unknown = 0] = "Unknown", e[e.VariantNotFound = 404] = "VariantNotFound", e[e.UnprocessableEntity = 422] = "UnprocessableEntity", e;
})({});
async function He(e, t) {
  const n = new URL(window.Shopify.routes.root + e, window.location.origin);
  try {
    const r = await fetch(n, {
      method: e === xe.GET ? "GET" : "POST",
      headers: { "Content-Type": "application/json" },
      body: t ? JSON.stringify(t) : void 0
    });
    return r.ok ? new et(await r.json()) : new Le(new ct(await r.json()));
  } catch (r) {
    return new Le(new ct({
      status: zt.Unknown,
      message: "An Unknown error Occured with a request to Shopify",
      description: r instanceof Error ? r.message : `Sending a request to ${e} with payload ${t} failed.`
    }));
  }
}
var lt = (e) => {
  const t = Hn(e);
  return He(xe.ADD, t);
}, Hn = (e) => ({ items: Sn(e).map((t) => typeof t == "object" ? {
  quantity: 1,
  ...t,
  properties: Object.assign({}, t.properties ?? {})
} : {
  id: t,
  quantity: 1,
  properties: {}
}) }), Vn = (e) => He(xe.CHANGE, e), qn = () => He(xe.GET), Un = (e) => {
  const t = { updates: e };
  return He(xe.UPDATE, t);
}, Wn = (e) => {
  let t = 0;
  const n = new EventTarget();
  e.store("cart", {
    name: "cart",
    section: "cart-drawer",
    isOpen: new URLSearchParams(location.search).get("cart") === "true",
    updating: !0,
    data: JSON.parse(document.querySelector("script#cart-data")?.textContent ?? "{}"),
    items: [],
    get totalItems() {
      return this.items.reduce((r, i) => r + i.quantity, 0);
    },
    get totalPrice() {
      return this.data.total_price;
    },
    init() {
      this.items = this.data.items, window.addEventListener("rebuy.beforeAdd", () => this.updating = !0), window.addEventListener("rebuy.add", () => this.update(async () => this.data = await this.getState())), n.dispatchEvent(new Event("init")), this.updating = !1;
    },
    async update(r) {
      n.dispatchEvent(new Event("update"));
      try {
        this.updating = !0, t++;
        const i = await r();
        return t && t--, t || (this.updating = !1, e.nextTick(() => this.items = this.data.items)), i;
      } catch (i) {
        return console.error(i), this.data = await this.getState(), this.updating = !1, e.nextTick(() => {
          this.items = this.data.items;
        }), this.data;
      }
    },
    toggle() {
      this.isOpen ? this.open() : this.close();
    },
    open() {
      this.isOpen || (this.isOpen = !0, n.dispatchEvent(new Event("open")));
    },
    close() {
      this.isOpen && (this.isOpen = !1, n.dispatchEvent(new Event("close")));
    },
    load() {
      n.dispatchEvent(new Event("load"));
    },
    handleError(r) {
      n.dispatchEvent(new CustomEvent("error", { detail: r.cause.message }));
    },
    async getState() {
      const r = (await qn()).inspectErr(this.handleError).unwrapOr(this.data);
      return queueMicrotask(this.load), r;
    },
    async addItem(r) {
      await this.update(async () => {
        (await lt(r)).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async removeItem(r) {
      await this.update(async () => {
        (await Un({ [r]: 0 })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async updateItem(r, i) {
      await this.update(async () => {
        (await Vn({
          id: r,
          ...i
        })).inspectErr(this.handleError), this.data = await this.getState();
      });
    },
    async addFromForm(r) {
      await this.update(async () => {
        const i = r instanceof HTMLFormElement ? [r] : document.querySelectorAll((r.startsWith("form") ? "" : r.startsWith("#") ? "form" : "form#") + r);
        try {
          (await lt(Array.prototype.map.call(i, (a) => (console.assert(a.reportValidity(), "Form is invalid"), Ln(new FormData(a)))).filter(Boolean))).inspectErr(this.handleError).unwrap(), this.data = await this.getState();
        } catch (a) {
          console.error(a);
        }
      }), this.open(), await this.update(async () => this.data = await this.getState()), e.nextTick(() => this.open());
    },
    addEventListener(r, i) {
      n.addEventListener(r, i);
    },
    removeEventListener(r, i) {
      n.removeEventListener(r, i);
    },
    dispatchEvent(r) {
      return n.dispatchEvent(r);
    }
  });
}, zn = window?.Shopify?.currency ?? {
  active: "USD",
  rate: 1
}, ut = `${window?.Shopify?.locale ?? "en"}-${window?.Shopify?.country ?? "US"}`, tt = (e, t = ut, n = {}) => new Intl.NumberFormat(t || ut, {
  style: "currency",
  currency: zn.active,
  currencyDisplay: "narrowSymbol",
  ...n
}).format(Number(e)), Kn = (e) => e.data("cartDrawer", () => ({
  activeUpdates: 0,
  abortController: new AbortController(),
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = e.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh, { signal: this.abortController.signal }), this.$store.cart.addEventListener("load", this.refresh, { signal: this.abortController.signal });
  },
  destroy() {
    this.abortController.abort();
  },
  async refresh() {
    const t = new URL(window.location.href), n = Te();
    this.activeUpdates++, t.searchParams.set("sections", n.join(","));
    const r = await fetch(t);
    if (n.length && --this.activeUpdates == 0) {
      const i = await r.json();
      he(Object.values(i).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async removeItem(t) {
    const n = { [t]: 0 }, r = Te();
    this.activeUpdates++;
    const i = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: n,
        sections: r.join(",")
      })
    });
    if (r.length && --this.activeUpdates == 0) {
      const a = await i.json();
      he(Object.values(a.sections).join(""), []);
    }
  },
  async updateItem(t, n) {
    const r = { [t]: n }, i = Te();
    this.activeUpdates++;
    const a = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: r,
        sections: i.join(",")
      })
    });
    if (i.length && --this.activeUpdates == 0) {
      const o = await a.json();
      he(Object.values(o.sections).join(""), []);
    }
  },
  async changeSellingPlan(t, n, r = 1) {
    const i = {
      id: t,
      selling_plan: n,
      quantity: r
    }, a = Te();
    this.activeUpdates++;
    const o = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...i,
        sections: a.join(",")
      })
    });
    if (a.length && --this.activeUpdates == 0) {
      const s = await o.json();
      he(Object.values(s.sections).join(""), []);
    }
  },
  formatMoney: tt
})), Te = () => {
  const e = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (t) => t?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(e));
}, Gn = (e) => e.data("collectionFilters", (t) => ({
  ...t,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), Yn = (e) => e.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (t) => !t && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), Jn = (e) => {
  e.addRootSelector(() => `[${e.prefixed("dynamic-image")}]`), e.addInitSelector(() => `[${e.prefixed("dynamic-image-broadcaster")}]`), e.directive("dynamic-image", Gt), e.directive("dynamic-image-broadcaster", Xn), e.directive("dynamic-image-image", Qn);
}, Kt = /* @__PURE__ */ new WeakMap(), Gt = (e, t, { Alpine: n }) => {
  console.log("Setting up Dynamic Image Node");
  const r = Kt.get(e);
  if (!r) return console.error("Dynamic Image Failed to Register: ", e, t.value);
  n.addScopeToNode(e, r);
};
Gt.inline = (e, t, { Alpine: n, cleanup: r }) => {
  console.log("Setting Dynamic Image Handler");
  const i = n.reactive({ image: null });
  Kt.set(e, i);
  const a = new AbortController();
  e.closest("section")?.addEventListener("dynamic-image-update", (o) => {
    console.log("Dynamic Image receiving Event"), i.image = o.detail;
  }, { signal: a.signal }), r(a.abort.bind(a));
};
var Xn = (e, { value: t, expression: n, modifiers: r }, { Alpine: i, cleanup: a }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), t === "intersect") {
    console.log("Dynamic Image Root:", n);
    const o = new IntersectionObserver((s) => {
      for (const c of s) c.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), Zn(e)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: n });
    r.includes("parent") && o.observe(e.parentElement), o.observe(e), a(o.disconnect.bind(o));
  }
}, Zn = (e) => {
  e.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(e.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, Qn = (e, t, { Alpine: n, effect: r }) => {
  if (!(e instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const i = e.content;
  let a = null;
  const o = n.$data(e);
  console.log("Registering Dynamic Image Effect"), r(() => {
    if (console.log("running Dynamic Image Effect"), "image" in o && o.image) {
      const s = o.image, c = document.importNode(i, !0).firstElementChild;
      if (!(c instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (n.bind(c, {
        "x-rias"() {
          return s.url;
        },
        width: s.width,
        height: s.height,
        alt: s.alt
      }), (a ?? e).after(c), new Animation(new KeyframeEffect(c, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), a) {
        const l = new Animation(new KeyframeEffect(a, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        l.play(), l.addEventListener("finish", a.remove.bind(a));
      }
      a = c;
    }
  });
}, er = (e) => e == null ? [] : Array.isArray(e) ? e.map((t) => Number(t)) : typeof e == "number" && !Number.isNaN(e) ? [e] : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean).map((t) => Number(t)) : [], tr = (e) => e ? Array.isArray(e) ? e.map(String) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean) : [] : [], nr = (e) => e ? typeof e == "string" ? e : String(e) : "", ke = (e) => {
  const t = e ?? {};
  let n = Number(t.cutOffHour);
  Number.isFinite(n) || (n = 14);
  let r = Number(t.leadTime);
  return Number.isFinite(r) || (r = 0), {
    cutOffHour: n,
    leadTime: r,
    messageHtml: nr(t.messageHtml),
    isCustomMessage: !!t.isCustomMessage,
    restrictedDays: er(t.restrictedDays),
    restrictedDates: tr(t.restrictedDates)
  };
}, dt = (e) => e.dayOfWeek % 7, rr = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], ir = (e) => {
  let t = Math.max(0, Math.floor(e));
  const n = Math.floor(t / 86400);
  t %= 86400;
  const r = Math.floor(t / 3600);
  return t %= 3600, {
    days: n,
    hours: r,
    minutes: Math.floor(t / 60),
    seconds: t % 60
  };
}, ar = (e) => {
  const t = e.dataset.esCfgId;
  if (!t) return ke(void 0);
  const n = document.getElementById(t);
  if (!n?.textContent?.trim()) return ke(void 0);
  try {
    return ke(JSON.parse(n.textContent));
  } catch {
    return ke(void 0);
  }
}, Je = "America/Chicago", or = (e) => {
  e.data("estimatedShipping", (t = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-CJmvQtEf.js"), Object.assign(this, ar(this.$el), t), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const n = Temporal.Now.zonedDateTimeISO(Je), r = this.nextCutoffDate(), i = r.epochNanoseconds - n.epochNanoseconds, { days: a, hours: o, minutes: s, seconds: c } = ir(i <= 0n ? 0 : Number(i / 1000000000n)), l = [];
      (l.length || a) && l.push(a === 1 ? `${a} day` : `${a} days`), (l.length || o) && l.push(o === 1 ? `${o} hour` : `${o} hours`), (l.length || s) && l.push(s === 1 ? `${s} minute` : `${s} minutes`), (l.length || c) && l.push(c === 1 ? `${c} second` : `${c} seconds`);
      const d = this.nextShippingDate(r), u = d.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : rr[dt(d)];
      this.message = String(this.messageHtml).replace("%countdown%", l.join(", ")).replace("%ship_day%", u);
    },
    nextCutoffDate() {
      const n = Temporal.Now.zonedDateTimeISO(Je);
      let r = Temporal.Now.zonedDateTimeISO(Je).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(r, n) === -1 && (r = r.add({ days: 1 })); this.isDateRestricted(r); ) r = r.add({ days: 1 });
      return r;
    },
    nextShippingDate(n) {
      let r = n, i = this.leadTime;
      for (; this.isDateRestricted(r) || i > 0; )
        r = r.add({ days: 1 }), this.isDateRestricted(r) || i--;
      return r;
    },
    isDateRestricted(n) {
      if (this.restrictedDays.includes(dt(n))) return !0;
      const r = n.toPlainDate().toString(), i = r.slice(5);
      return this.restrictedDates.some((a) => a === r || a === i);
    }
  }));
}, sr = (e) => {
  e.data("filterController", (r) => {
    const i = [];
    return r || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await e.nextTick(), this.facetChange(!1), i.push(e.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: a }) {
        this.facetData = a ? JSON.parse(a) : this.facetChange();
        const o = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((l) => {
          l.checked = o.some(([d, u]) => d === l.name && u === l.value);
        });
        const s = o.find(([l]) => l === "sort_by")?.[1];
        if (!s) return;
        const c = document.querySelector('select[name="sort_by"]');
        c && (c.value = s);
      },
      destroy() {
        i.forEach(e.release);
      },
      _expanded: [!0],
      expanded(a) {
        return this._expanded[a];
      },
      expand(a) {
        this._expanded[a] = !this._expanded[a];
      },
      open: !1,
      fadeTransition: Cn,
      slideTransition: Bt,
      facetData: [],
      facetChange(a = !0) {
        return this.facetData = Object.values(this.forms).flatMap((o) => Array.from(new FormData(o).entries())).filter(([o, s]) => !(o === "sort_by" && s === "manual" || o === "page" && (a || s === "1"))), this.facetData;
      },
      filterProducts() {
        n(this.facetData, r);
      },
      get isFiltered() {
        return this.facetData.some(([a]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(a));
      }
    };
  });
  let t = !0;
  const n = Tn(async (r, i) => {
    const a = new URL(window.location.href);
    a.search = new URLSearchParams(r).toString();
    const o = await Rn(a);
    if (!o) return;
    t || he(o, i);
    const s = a.toString() === window.location.href;
    history[t || s ? "replaceState" : "pushState"](JSON.stringify(r), "", a.toString()), t = !1;
  });
}, cr = (e) => {
  e.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, e.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), e.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((t) => t) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, lr = (e) => e.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const t = this.$refs.menuDrawer;
    if (!t) return;
    const n = t.closest("section > :is(div.relative, div.absolute)");
    if (!n) return;
    const r = n.getBoundingClientRect(), i = r.y + r.height;
    this.size = `${i}px`;
  },
  adjustToLargestPart(t) {
    const n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT);
    let r = 0, i = t;
    do
      r = Math.max(r, i.scrollHeight);
    while (i = n.nextNode());
    this.size = `${r + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((t) => t.removeAttribute("open"));
  }
})), ur = (e) => e.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (t) => {
      !t && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(t = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, t && this.$store.modal.close();
  }
})), dr = (e) => {
  e.addRootSelector(() => `[${e.prefixed("panel-stack")}]`), e.directive("panel-stack", hr);
}, fr = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), hr = (e, { expression: t }, { Alpine: n, effect: r, cleanup: i }) => {
  const a = n.reactive({ index: 0 }), o = new AbortController();
  i(o.abort.bind(o)), r(() => {
    const s = a.index;
    vr(e).forEach((c, l) => {
      c.classList.toggle("panel-current", l === s), c.classList.toggle("panel-previous", l < s), c.classList.toggle("panel-next", l > s), c.setAttribute("aria-hidden", String(l !== s));
    });
  }), queueMicrotask(() => {
    if (o.signal.aborted) return;
    const s = mr(e, t, pr(n));
    s && (br(s, e, a, o.signal, r), gr(s, e, a, n, r)), queueMicrotask(() => e.classList.add("panels-ready"));
  });
}, vr = (e) => Array.from(e.children).filter((t) => t instanceof HTMLElement && !fr.has(t.tagName)), Yt = (e) => {
  const t = e.prefixed("accordion");
  return `[${t}], [${t}\\.open], [${t}\\.closed]`;
}, pr = (e) => `[data-panel-trigger], ${Yt(e)}`, nt = (e, t, n) => Array.from(e.querySelectorAll(n)).filter((r) => !t.contains(r)), mr = (e, t, n) => {
  if (t) return e.closest(t) ?? document.querySelector(t);
  let r = e.parentElement;
  for (; r; ) {
    if (nt(r, e, n).length) return r;
    if (r.tagName === "SECTION") return null;
    r = r.parentElement;
  }
  return null;
}, gr = (e, t, n, r, i) => {
  nt(e, t, Yt(r)).map((a) => r.evaluate(a, "$accordion")).forEach((a, o) => {
    a && i(() => {
      a.active && (n.index = o);
    });
  });
}, br = (e, t, n, r, i) => {
  const a = nt(e, t, "[data-panel-trigger]");
  if (!a.length) return;
  const o = a.map((s) => [s.dataset.panelTriggerTarget === "parent" ? s.parentElement ?? s : s, s.dataset.panelTrigger ?? "hover"]);
  o.forEach(([s, c], l) => {
    const d = () => {
      n.index = l;
    };
    c === "click" ? s.addEventListener("click", d, { signal: r }) : c === "hover" ? (s.addEventListener("pointerenter", d, { signal: r }), s.addEventListener("focusin", d, { signal: r })) : console.error("x-panel-trigger action: ", c, " is invalid. Use 'hover' or 'click'.");
  }), i(() => {
    const s = n.index;
    o.forEach(([c], l) => c.classList.toggle("trigger-current", l === s));
  });
}, yr = (e) => {
  e.data("productCard", (t) => ({
    variant: t,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: n, description: r, color: i } = this.variant;
      return {
        name: n,
        description: r,
        color: i
      };
    },
    get colorDisplay() {
      const { name: n } = this.variant;
      return `${n}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(n) {
      Object.assign(this, { variant: n });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    },
    formatMoney: tt
  }));
}, wr = (e) => {
  e.data("quickOrder", (t) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((n) => n.product_id === t);
    },
    get quantity() {
      return this.productEntries.reduce((n, r) => n + r.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((n, r) => n + r.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: n } of this.productEntries)
        await this.cart.removeItem(n), this.$dispatch("removeall", { id: n });
      this.removing = !1;
    }
  })), e.data("quickOrderRow", (t, n) => ({
    quantity: e.store("cart").items.find((r) => r.id === Number(t))?.quantity ?? 0,
    price: n,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), e.data("quickQuantity", (t) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(n) {
      n = Math.max(0, n), this.q = n;
    }
  }));
}, xr = (e) => e.data("sizes", (t) => ({
  ...t,
  changeSize(n) {
    this.$dispatch("product-change", { product: n.product }), history.replaceState(null, n.product.title, n.url);
  }
})), Er = (e) => {
  e.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const t = this.PDPATC.getBoundingClientRect();
      this.show = t.top < 25;
    }
  }));
}, Sr = (e) => {
  e.addRootSelector(() => `[${e.prefixed("stickyheader")}]`), e.directive("stickyheader", (t, n, { cleanup: r }) => {
    console.log("checking sticky header");
    const i = t.closest("section");
    if (!i || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const a = new Animation(new KeyframeEffect(i, [{ top: "0px" }, { get top() {
      return `-${t.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    a.persist(), a.reverse(), a.finish();
    const o = e.effect(() => {
      a.playbackRate = +(e.$scroll.direction === "down" && !e.$scroll.nearTop && !e.store("search").isOpen) * 2 - 1;
    });
    r(() => e.release(o));
  });
}, Tr = [
  Nn,
  On,
  _n,
  Jn,
  or,
  In,
  Kn,
  Gn,
  Yn,
  sr,
  cr,
  lr,
  ur,
  dr,
  yr,
  wr,
  xr,
  Er,
  Sr
], Fe = Math.min, ne = Math.max, Re = Math.round, Ce = Math.floor, X = (e) => ({
  x: e,
  y: e
}), kr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Cr = {
  start: "end",
  end: "start"
};
function ft(e, t, n) {
  return ne(e, Fe(t, n));
}
function Ve(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function re(e) {
  return e.split("-")[0];
}
function qe(e) {
  return e.split("-")[1];
}
function Jt(e) {
  return e === "x" ? "y" : "x";
}
function Xt(e) {
  return e === "y" ? "height" : "width";
}
function Ue(e) {
  return ["top", "bottom"].includes(re(e)) ? "y" : "x";
}
function Zt(e) {
  return Jt(Ue(e));
}
function Nr(e, t, n) {
  n === void 0 && (n = !1);
  const r = qe(e), i = Zt(e), a = Xt(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = Ae(o)), [o, Ae(o)];
}
function Or(e) {
  const t = Ae(e);
  return [
    Xe(e),
    t,
    Xe(t)
  ];
}
function Xe(e) {
  return e.replace(/start|end/g, (t) => Cr[t]);
}
function Ir(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function _r(e, t, n, r) {
  const i = qe(e);
  let a = Ir(re(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(Xe)))), a;
}
function Ae(e) {
  return e.replace(/left|right|bottom|top/g, (t) => kr[t]);
}
function Lr(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Fr(e) {
  return typeof e != "number" ? Lr(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function De(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function ht(e, t, n) {
  let { reference: r, floating: i } = e;
  const a = Ue(t), o = Zt(t), s = Xt(o), c = re(t), l = a === "y", d = r.x + r.width / 2 - i.width / 2, u = r.y + r.height / 2 - i.height / 2, v = r[s] / 2 - i[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: u
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (qe(t)) {
    case "start":
      p[o] -= v * (n && l ? -1 : 1);
      break;
    case "end":
      p[o] += v * (n && l ? -1 : 1);
      break;
  }
  return p;
}
var Rr = async (e, t, n) => {
  const { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), { x: d, y: u } = ht(l, r, c), v = r, p = {}, g = 0;
  for (let y = 0; y < s.length; y++) {
    const { name: m, fn: x } = s[y], { x: O, y: I, data: A, reset: F } = await x({
      x: d,
      y: u,
      initialPlacement: r,
      placement: v,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = O ?? d, u = I ?? u, p = {
      ...p,
      [m]: {
        ...p[m],
        ...A
      }
    }, F && g <= 50) {
      g++, typeof F == "object" && (F.placement && (v = F.placement), F.rects && (l = F.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : F.rects), { x: d, y: u } = ht(l, v, c)), y = -1;
      continue;
    }
  }
  return {
    x: d,
    y: u,
    placement: v,
    strategy: i,
    middlewareData: p
  };
};
async function Qt(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: r, y: i, platform: a, rects: o, elements: s, strategy: c } = e, { boundary: l = "clippingAncestors", rootBoundary: d = "viewport", elementContext: u = "floating", altBoundary: v = !1, padding: p = 0 } = Ve(t, e), g = Fr(p), y = s[v ? u === "floating" ? "reference" : "floating" : u], m = De(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), x = u === "floating" ? {
    ...o.floating,
    x: r,
    y: i
  } : o.reference, O = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), I = await (a.isElement == null ? void 0 : a.isElement(O)) ? await (a.getScale == null ? void 0 : a.getScale(O)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = De(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: x,
    offsetParent: O,
    strategy: c
  }) : x);
  return {
    top: (m.top - A.top + g.top) / I.y,
    bottom: (A.bottom - m.bottom + g.bottom) / I.y,
    left: (m.left - A.left + g.left) / I.x,
    right: (A.right - m.right + g.right) / I.x
  };
}
var Ar = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const { placement: i, middlewareData: a, rects: o, initialPlacement: s, platform: c, elements: l } = t, { mainAxis: d = !0, crossAxis: u = !0, fallbackPlacements: v, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: y = !0, ...m } = Ve(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset) return {};
      const x = re(i), O = re(s) === s, I = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), A = v || (O || !y ? [Ae(s)] : Or(s));
      !v && g !== "none" && A.push(..._r(s, y, g, I));
      const F = [s, ...A], D = await Qt(t, m), k = [];
      let L = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && k.push(D[x]), u) {
        const S = Nr(i, o, I);
        k.push(D[S[0]], D[S[1]]);
      }
      if (L = [...L, {
        placement: i,
        overflows: k
      }], !k.every((S) => S <= 0)) {
        var U, z;
        const S = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, f = F[S];
        if (f) return {
          data: {
            index: S,
            overflows: L
          },
          reset: { placement: f }
        };
        let h = (z = L.filter((b) => b.overflows[0] <= 0).sort((b, E) => b.overflows[1] - E.overflows[1])[0]) == null ? void 0 : z.placement;
        if (!h) switch (p) {
          case "bestFit": {
            var M;
            const b = (M = L.map((E) => [E.placement, E.overflows.filter((w) => w > 0).reduce((w, N) => w + N, 0)]).sort((E, w) => E[1] - w[1])[0]) == null ? void 0 : M[0];
            b && (h = b);
            break;
          }
          case "initialPlacement":
            h = s;
            break;
        }
        if (i !== h) return { reset: { placement: h } };
      }
      return {};
    }
  };
};
async function Dr(e, t) {
  const { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = re(n), s = qe(n), c = Ue(n) === "y", l = ["left", "top"].includes(o) ? -1 : 1, d = a && c ? -1 : 1, u = Ve(t, e);
  let { mainAxis: v, crossAxis: p, alignmentAxis: g } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), c ? {
    x: p * d,
    y: v * l
  } : {
    x: v * l,
    y: p * d
  };
}
var $r = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const { x: n, y: r } = t, i = await Dr(t, e);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, Mr = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (m) => {
        let { x, y: O } = m;
        return {
          x,
          y: O
        };
      } }, ...c } = Ve(e, t), l = {
        x: n,
        y: r
      }, d = await Qt(t, c), u = Ue(re(i)), v = Jt(u);
      let p = l[v], g = l[u];
      if (a) {
        const m = v === "y" ? "top" : "left", x = v === "y" ? "bottom" : "right", O = p + d[m], I = p - d[x];
        p = ft(O, p, I);
      }
      if (o) {
        const m = u === "y" ? "top" : "left", x = u === "y" ? "bottom" : "right", O = g + d[m], I = g - d[x];
        g = ft(O, g, I);
      }
      const y = s.fn({
        ...t,
        [v]: p,
        [u]: g
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - r
        }
      };
    }
  };
};
function Z(e) {
  return en(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function V(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Y(e) {
  var t;
  return (t = (en(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function en(e) {
  return e instanceof Node || e instanceof V(e).Node;
}
function G(e) {
  return e instanceof Element || e instanceof V(e).Element;
}
function W(e) {
  return e instanceof HTMLElement || e instanceof V(e).HTMLElement;
}
function vt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof V(e).ShadowRoot;
}
function Ee(e) {
  const { overflow: t, overflowX: n, overflowY: r, display: i } = q(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Pr(e) {
  return [
    "table",
    "td",
    "th"
  ].includes(Z(e));
}
function rt(e) {
  const t = it(), n = q(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((r) => (n.willChange || "").includes(r)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((r) => (n.contain || "").includes(r));
}
function jr(e) {
  let t = le(e);
  for (; W(t) && !We(t); ) {
    if (rt(t)) return t;
    t = le(t);
  }
  return null;
}
function it() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function We(e) {
  return [
    "html",
    "body",
    "#document"
  ].includes(Z(e));
}
function q(e) {
  return V(e).getComputedStyle(e);
}
function ze(e) {
  return G(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function le(e) {
  if (Z(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || vt(e) && e.host || Y(e);
  return vt(t) ? t.host : t;
}
function tn(e) {
  const t = le(e);
  return We(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : W(t) && Ee(t) ? t : tn(t);
}
function me(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = tn(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = V(i);
  return a ? t.concat(o, o.visualViewport || [], Ee(i) ? i : [], o.frameElement && n ? me(o.frameElement) : []) : t.concat(i, me(i, [], n));
}
function nn(e) {
  const t = q(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = W(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Re(n) !== a || Re(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function at(e) {
  return G(e) ? e : e.contextElement;
}
function ce(e) {
  const t = at(e);
  if (!W(t)) return X(1);
  const n = t.getBoundingClientRect(), { width: r, height: i, $: a } = nn(t);
  let o = (a ? Re(n.width) : n.width) / r, s = (a ? Re(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
var Br = /* @__PURE__ */ X(0);
function rn(e) {
  const t = V(e);
  return !it() || !t.visualViewport ? Br : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Hr(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== V(e) ? !1 : t;
}
function ie(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = at(e);
  let o = X(1);
  t && (r ? G(r) && (o = ce(r)) : o = ce(e));
  const s = Hr(a, n, r) ? rn(a) : X(0);
  let c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, d = i.width / o.x, u = i.height / o.y;
  if (a) {
    const v = V(a), p = r && G(r) ? V(r) : r;
    let g = v.frameElement;
    for (; g && r && p !== v; ) {
      const y = ce(g), m = g.getBoundingClientRect(), x = q(g), O = m.left + (g.clientLeft + parseFloat(x.paddingLeft)) * y.x, I = m.top + (g.clientTop + parseFloat(x.paddingTop)) * y.y;
      c *= y.x, l *= y.y, d *= y.x, u *= y.y, c += O, l += I, g = V(g).frameElement;
    }
  }
  return De({
    width: d,
    height: u,
    x: c,
    y: l
  });
}
function Vr(e) {
  let { rect: t, offsetParent: n, strategy: r } = e;
  const i = W(n), a = Y(n);
  if (n === a) return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = X(1);
  const c = X(0);
  if ((i || !i && r !== "fixed") && ((Z(n) !== "body" || Ee(a)) && (o = ze(n)), W(n))) {
    const l = ie(n);
    s = ce(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: t.width * s.x,
    height: t.height * s.y,
    x: t.x * s.x - o.scrollLeft * s.x + c.x,
    y: t.y * s.y - o.scrollTop * s.y + c.y
  };
}
function qr(e) {
  return Array.from(e.getClientRects());
}
function an(e) {
  return ie(Y(e)).left + ze(e).scrollLeft;
}
function Ur(e) {
  const t = Y(e), n = ze(e), r = e.ownerDocument.body, i = ne(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = ne(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + an(e);
  const s = -n.scrollTop;
  return q(r).direction === "rtl" && (o += ne(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function Wr(e, t) {
  const n = V(e), r = Y(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    const l = it();
    (!l || l && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: c
  };
}
function zr(e, t) {
  const n = ie(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = W(e) ? ce(e) : X(1);
  return {
    width: e.clientWidth * a.x,
    height: e.clientHeight * a.y,
    x: i * a.x,
    y: r * a.y
  };
}
function pt(e, t, n) {
  let r;
  if (t === "viewport") r = Wr(e, n);
  else if (t === "document") r = Ur(Y(e));
  else if (G(t)) r = zr(t, n);
  else {
    const i = rn(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return De(r);
}
function on(e, t) {
  const n = le(e);
  return n === t || !G(n) || We(n) ? !1 : q(n).position === "fixed" || on(n, t);
}
function Kr(e, t) {
  const n = t.get(e);
  if (n) return n;
  let r = me(e, [], !1).filter((s) => G(s) && Z(s) !== "body"), i = null;
  const a = q(e).position === "fixed";
  let o = a ? le(e) : e;
  for (; G(o) && !We(o); ) {
    const s = q(o), c = rt(o);
    !c && s.position === "fixed" && (i = null), (a ? !c && !i : !c && s.position === "static" && i && ["absolute", "fixed"].includes(i.position) || Ee(o) && !c && on(e, o)) ? r = r.filter((l) => l !== o) : i = s, o = le(o);
  }
  return t.set(e, r), r;
}
function Gr(e) {
  let { element: t, boundary: n, rootBoundary: r, strategy: i } = e;
  const a = [...n === "clippingAncestors" ? Kr(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((c, l) => {
    const d = pt(t, l, i);
    return c.top = ne(d.top, c.top), c.right = Fe(d.right, c.right), c.bottom = Fe(d.bottom, c.bottom), c.left = ne(d.left, c.left), c;
  }, pt(t, o, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Yr(e) {
  return nn(e);
}
function Jr(e, t, n) {
  const r = W(t), i = Y(t), a = n === "fixed", o = ie(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = X(0);
  if (r || !r && !a)
    if ((Z(t) !== "body" || Ee(i)) && (s = ze(t)), r) {
      const l = ie(t, !0, a, t);
      c.x = l.x + t.clientLeft, c.y = l.y + t.clientTop;
    } else i && (c.x = an(i));
  return {
    x: o.left + s.scrollLeft - c.x,
    y: o.top + s.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function mt(e, t) {
  return !W(e) || q(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function sn(e, t) {
  const n = V(e);
  if (!W(e)) return n;
  let r = mt(e, t);
  for (; r && Pr(r) && q(r).position === "static"; ) r = mt(r, t);
  return r && (Z(r) === "html" || Z(r) === "body" && q(r).position === "static" && !rt(r)) ? n : r || jr(e) || n;
}
var Xr = async function(e) {
  let { reference: t, floating: n, strategy: r } = e;
  const i = this.getOffsetParent || sn, a = this.getDimensions;
  return {
    reference: Jr(t, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function Zr(e) {
  return q(e).direction === "rtl";
}
var Qr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vr,
  getDocumentElement: Y,
  getClippingRect: Gr,
  getOffsetParent: sn,
  getElementRects: Xr,
  getClientRects: qr,
  getDimensions: Yr,
  getScale: ce,
  isElement: G,
  isRTL: Zr
};
function ei(e, t) {
  let n = null, r;
  const i = Y(e);
  function a() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const { left: l, top: d, width: u, height: v } = e.getBoundingClientRect();
    if (s || t(), !u || !v) return;
    const p = Ce(d), g = Ce(i.clientWidth - (l + u)), y = Ce(i.clientHeight - (d + v)), m = Ce(l), x = {
      rootMargin: -p + "px " + -g + "px " + -y + "px " + -m + "px",
      threshold: ne(0, Fe(1, c)) || 1
    };
    let O = !0;
    function I(A) {
      const F = A[0].intersectionRatio;
      if (F !== c) {
        if (!O) return o();
        F ? o(!1, F) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      O = !1;
    }
    try {
      n = new IntersectionObserver(I, {
        ...x,
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(I, x);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function ti(e, t, n, r) {
  r === void 0 && (r = {});
  const { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = at(e), d = i || a ? [...l ? me(l) : [], ...me(t)] : [];
  d.forEach((x) => {
    i && x.addEventListener("scroll", n, { passive: !0 }), a && x.addEventListener("resize", n);
  });
  const u = l && s ? ei(l, n) : null;
  let v = -1, p = null;
  o && (p = new ResizeObserver((x) => {
    let [O] = x;
    O && O.target === l && p && (p.unobserve(t), cancelAnimationFrame(v), v = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), l && !c && p.observe(l), p.observe(t));
  let g, y = c ? ie(e) : null;
  c && m();
  function m() {
    const x = ie(e);
    y && (x.x !== y.x || x.y !== y.y || x.width !== y.width || x.height !== y.height) && n(), y = x, g = requestAnimationFrame(m);
  }
  return n(), () => {
    d.forEach((x) => {
      i && x.removeEventListener("scroll", n), a && x.removeEventListener("resize", n);
    }), u && u(), p && p.disconnect(), p = null, c && cancelAnimationFrame(g);
  };
}
var ni = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Qr,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return Rr(e, t, {
    ...i,
    platform: a
  });
};
function ri(e) {
  e.magic("anchor", (t) => {
    if (!t._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return t._x_anchor;
  }), e.interceptClone((t, n) => {
    t && t._x_anchor && !n._x_anchor && (n._x_anchor = t._x_anchor);
  }), e.directive("anchor", e.skipDuringClone((t, { expression: n, modifiers: r, value: i }, { evaluate: a, effect: o, cleanup: s }) => {
    let { placement: c, offsetValue: l, unstyled: d, strategy: u, allowFlip: v } = bt(r);
    t._x_anchor = e.reactive({
      x: 0,
      y: 0
    });
    let p = null, g = null;
    o(() => {
      let y = a(n);
      if (y && p !== y) {
        g && g(), p = y;
        let m = () => {
          let x;
          ni(y, t, {
            placement: c,
            strategy: u,
            middleware: [
              v && Ar(),
              Mr({ padding: 5 }),
              $r(l)
            ]
          }).then(({ x: O, y: I }) => {
            d || gt(t, O, I, u), JSON.stringify({
              x: O,
              y: I
            }) !== x && (t._x_anchor.x = O, t._x_anchor.y = I), x = JSON.stringify({
              x: O,
              y: I
            });
          });
        };
        g = ti(y, t, () => m());
      }
    }), s(() => {
      g && g();
    });
  }, (t, { expression: n, modifiers: r, value: i }, { cleanup: a, evaluate: o }) => {
    let { placement: s, offsetValue: c, unstyled: l, strategy: d } = bt(r);
    t._x_anchor && (l || gt(t, t._x_anchor.x, t._x_anchor.y, d));
  }));
}
function gt(e, t, n, r = "absolute") {
  Object.assign(e.style, {
    left: t + "px",
    top: n + "px",
    position: r
  });
}
function bt(e) {
  let t = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((o) => e.includes(o)), n = 0;
  if (e.includes("offset")) {
    let o = e.findIndex((s) => s === "offset");
    n = e[o + 1] !== void 0 ? Number(e[o + 1]) : n;
  }
  let r = e.includes("no-style"), i = !e.includes("noflip"), a = e.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: t,
    offsetValue: n,
    unstyled: r,
    strategy: a,
    allowFlip: i
  };
}
var ii = ri;
function ai(e) {
  e.directive("collapse", t), t.inline = (n, { modifiers: r }) => {
    r.includes("min") && (n._x_doShow = () => {
    }, n._x_doHide = () => {
    });
  };
  function t(n, { modifiers: r }) {
    let i = yt(r, "duration", 250) / 1e3, a = yt(r, "min", 0), o = !r.includes("min");
    n._x_isShown || (n.style.height = `${a}px`), !n._x_isShown && o && (n.hidden = !0), n._x_isShown || (n.style.overflow = "hidden");
    let s = (l, d) => {
      let u = e.setStyles(l, d);
      return d.height ? () => {
      } : u;
    }, c = {
      transitionProperty: "height",
      transitionDuration: `${i}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    n._x_transition = {
      in(l = () => {
      }, d = () => {
      }) {
        o && (n.hidden = !1), o && (n.style.display = null);
        let u = n.getBoundingClientRect().height;
        n.style.height = "auto";
        let v = n.getBoundingClientRect().height;
        u === v && (u = a), e.transition(n, e.setStyles, {
          during: c,
          start: { height: u + "px" },
          end: { height: v + "px" }
        }, () => n._x_isShown = !0, () => {
          Math.abs(n.getBoundingClientRect().height - v) < 1 && (n.style.overflow = null);
        });
      },
      out(l = () => {
      }, d = () => {
      }) {
        let u = n.getBoundingClientRect().height;
        e.transition(n, s, {
          during: c,
          start: { height: u + "px" },
          end: { height: a + "px" }
        }, () => n.style.overflow = "hidden", () => {
          n._x_isShown = !1, n.style.height == `${a}px` && o && (n.style.display = "none", n.hidden = !0);
        });
      }
    };
  }
}
function yt(e, t, n) {
  if (e.indexOf(t) === -1) return n;
  const r = e[e.indexOf(t) + 1];
  if (!r) return n;
  if (t === "duration") {
    let i = r.match(/([0-9]+)ms/);
    if (i) return i[1];
  }
  if (t === "min") {
    let i = r.match(/([0-9]+)px/);
    if (i) return i[1];
  }
  return r;
}
var oi = ai, cn = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], $e = /* @__PURE__ */ cn.join(","), ln = typeof Element > "u", ae = ln ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Me = !ln && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Pe = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert");
  return i === "" || i === "true" || n && t && (typeof t.closest == "function" ? t.closest("[inert]") : Pe(t.parentNode));
}, si = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, un = function(t, n, r) {
  if (Pe(t)) return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll($e));
  return n && ae.call(t, $e) && i.unshift(t), i = i.filter(r), i;
}, je = function(t, n, r) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var o = a.shift();
    if (!Pe(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), c = je(s.length ? s : o.children, !0, r);
        r.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: o,
          candidates: c
        });
      } else {
        ae.call(o, $e) && r.filter(o) && (n || !t.includes(o)) && i.push(o);
        var l = o.shadowRoot || typeof r.getShadowRoot == "function" && r.getShadowRoot(o), d = !Pe(l, !1) && (!r.shadowRootFilter || r.shadowRootFilter(o));
        if (l && d) {
          var u = je(l === !0 ? o.children : l.children, !0, r);
          r.flatten ? i.push.apply(i, u) : i.push({
            scopeParent: o,
            candidates: u
          });
        } else a.unshift.apply(a, o.children);
      }
  }
  return i;
}, dn = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, te = function(t) {
  if (!t) throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || si(t)) && !dn(t) ? 0 : t.tabIndex;
}, ci = function(t, n) {
  var r = te(t);
  return r < 0 && n && !dn(t) ? 0 : r;
}, li = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, fn = function(t) {
  return t.tagName === "INPUT";
}, ui = function(t) {
  return fn(t) && t.type === "hidden";
}, di = function(t) {
  return t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
}, fi = function(t, n) {
  for (var r = 0; r < t.length; r++) if (t[r].checked && t[r].form === n) return t[r];
}, hi = function(t) {
  if (!t.name) return !0;
  var n = t.form || Me(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") i = r(window.CSS.escape(t.name));
  else try {
    i = r(t.name);
  } catch (o) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
  }
  var a = fi(i, t.form);
  return !a || a === t;
}, vi = function(t) {
  return fn(t) && t.type === "radio";
}, pi = function(t) {
  return vi(t) && !hi(t);
}, mi = function(t) {
  var n, r = t && Me(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== t) {
    var o, s, c;
    for (a = !!((o = i) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (c = t.ownerDocument) !== null && c !== void 0 && c.contains(t)); !a && i; ) {
      var l, d, u;
      r = Me(i), i = (l = r) === null || l === void 0 ? void 0 : l.host, a = !!((d = i) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return a;
}, wt = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, gi = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t)
    return !t.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(t).visibility === "hidden") return !0;
  var a = ae.call(t, "details>summary:first-of-type") ? t.parentElement : t;
  if (ae.call(a, "details:not([open]) *")) return !0;
  if (!r || r === "full" || r === "full-native" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var o = t; t; ) {
        var s = t.parentElement, c = Me(t);
        if (s && !s.shadowRoot && i(s) === !0) return wt(t);
        t.assignedSlot ? t = t.assignedSlot : !s && c !== t.ownerDocument ? t = c.host : t = s;
      }
      t = o;
    }
    if (mi(t)) return !t.getClientRects().length;
    if (r !== "legacy-full") return !0;
  } else if (r === "non-zero-area") return wt(t);
  return !1;
}, bi = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND") return ae.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Be = function(t, n) {
  return !(n.disabled || ui(n) || gi(n, t) || di(n) || bi(n));
}, Ze = function(t, n) {
  return !(pi(n) || te(n) < 0 || !Be(t, n));
}, yi = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, hn = function(t) {
  var n = [], r = [];
  return t.forEach(function(i, a) {
    var o = !!i.scopeParent, s = o ? i.scopeParent : i, c = ci(s, o), l = o ? hn(i.candidates) : s;
    c === 0 ? o ? n.push.apply(n, l) : n.push(s) : r.push({
      documentOrder: a,
      tabIndex: c,
      item: i,
      isScope: o,
      content: l
    });
  }), r.sort(li).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, wi = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = je([t], n.includeContainer, {
    filter: Ze.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: yi
  }) : r = un(t, n.includeContainer, Ze.bind(null, n)), hn(r);
}, vn = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = je([t], n.includeContainer, {
    filter: Be.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = un(t, n.includeContainer, Be.bind(null, n)), r;
}, se = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return ae.call(t, $e) === !1 ? !1 : Ze(n, t);
}, xi = /* @__PURE__ */ cn.concat("iframe:not([inert]):not([inert] *)").join(","), Oe = function(t, n) {
  if (n = n || {}, !t) throw new Error("No node provided");
  return ae.call(t, xi) === !1 ? !1 : Be(n, t);
};
function Qe(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ei(e) {
  if (Array.isArray(e)) return Qe(e);
}
function xt(e, t, n, r, i, a, o) {
  try {
    var s = e[a](o), c = s.value;
  } catch (l) {
    n(l);
    return;
  }
  s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Et(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var a = e.apply(t, n);
      function o(c) {
        xt(a, r, i, o, s, "next", c);
      }
      function s(c) {
        xt(a, r, i, o, s, "throw", c);
      }
      o(void 0);
    });
  };
}
function St(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = pn(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? { done: !0 } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, o = !0, s = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return o = c.done, c;
    },
    e: function(c) {
      s = !0, a = c;
    },
    f: function() {
      try {
        o || n.return == null || n.return();
      } finally {
        if (s) throw a;
      }
    }
  };
}
function Si(e, t, n) {
  return (t = Oi(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Ti(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ki() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Tt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function kt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tt(Object(n), !0).forEach(function(r) {
      Si(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Tt(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ve() {
  var e, t, n = typeof Symbol == "function" ? Symbol : {}, r = n.iterator || "@@iterator", i = n.toStringTag || "@@toStringTag";
  function a(p, g, y, m) {
    var x = g && g.prototype instanceof s ? g : s, O = Object.create(x.prototype);
    return H(O, "_invoke", (function(I, A, F) {
      var D, k, L, U = 0, z = F || [], M = !1, S = {
        p: 0,
        n: 0,
        v: e,
        a: f,
        f: f.bind(e, 4),
        d: function(h, b) {
          return D = h, k = 0, L = e, S.n = b, o;
        }
      };
      function f(h, b) {
        for (k = h, L = b, t = 0; !M && U && !E && t < z.length; t++) {
          var E, w = z[t], N = S.p, T = w[2];
          h > 3 ? (E = T === b) && (L = w[(k = w[4]) ? 5 : (k = 3, 3)], w[4] = w[5] = e) : w[0] <= N && ((E = h < 2 && N < w[1]) ? (k = 0, S.v = b, S.n = w[1]) : N < T && (E = h < 3 || w[0] > b || b > T) && (w[4] = h, w[5] = b, S.n = T, k = 0));
        }
        if (E || h > 1) return o;
        throw M = !0, b;
      }
      return function(h, b, E) {
        if (U > 1) throw TypeError("Generator is already running");
        for (M && b === 1 && f(b, E), k = b, L = E; (t = k < 2 ? e : L) || !M; ) {
          D || (k ? k < 3 ? (k > 1 && (S.n = -1), f(k, L)) : S.n = L : S.v = L);
          try {
            if (U = 2, D) {
              if (k || (h = "next"), t = D[h]) {
                if (!(t = t.call(D, L))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                L = t.value, k < 2 && (k = 0);
              } else k === 1 && (t = D.return) && t.call(D), k < 2 && (L = TypeError("The iterator does not provide a '" + h + "' method"), k = 1);
              D = e;
            } else if ((t = (M = S.n < 0) ? L : I.call(A, S)) !== o) break;
          } catch (w) {
            D = e, k = 1, L = w;
          } finally {
            U = 1;
          }
        }
        return {
          value: t,
          done: M
        };
      };
    })(p, y, m), !0), O;
  }
  var o = {};
  function s() {
  }
  function c() {
  }
  function l() {
  }
  t = Object.getPrototypeOf;
  var d = [][r] ? t(t([][r]())) : (H(t = {}, r, function() {
    return this;
  }), t), u = l.prototype = s.prototype = Object.create(d);
  function v(p) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(p, l) : (p.__proto__ = l, H(p, i, "GeneratorFunction")), p.prototype = Object.create(u), p;
  }
  return c.prototype = l, H(u, "constructor", l), H(l, "constructor", c), c.displayName = "GeneratorFunction", H(l, i, "GeneratorFunction"), H(u), H(u, i, "Generator"), H(u, r, function() {
    return this;
  }), H(u, "toString", function() {
    return "[object Generator]";
  }), (ve = function() {
    return {
      w: a,
      m: v
    };
  })();
}
function H(e, t, n, r) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch {
    i = 0;
  }
  H = function(a, o, s, c) {
    function l(d, u) {
      H(a, d, function(v) {
        return this._invoke(d, u, v);
      });
    }
    o ? i ? i(a, o, {
      value: s,
      enumerable: !c,
      configurable: !c,
      writable: !c
    }) : a[o] = s : (l("next", 0), l("throw", 1), l("return", 2));
  }, H(e, t, n, r);
}
function Ci(e) {
  return Ei(e) || Ti(e) || pn(e) || ki();
}
function Ni(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Oi(e) {
  var t = Ni(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function pn(e, t) {
  if (e) {
    if (typeof e == "string") return Qe(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Qe(e, t) : void 0;
  }
}
var K = {
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  activateTrap: function(t, n) {
    n !== K.getActiveTrap(t) && K.pauseTrap(t);
    var r = t.indexOf(n);
    r === -1 || t.splice(r, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), K.unpauseTrap(t);
  },
  pauseTrap: function(t) {
    var n = K.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  unpauseTrap: function(t) {
    var n = K.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Ii = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, _i = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, pe = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Li = function(t) {
  return pe(t) && !t.shiftKey;
}, Fi = function(t) {
  return pe(t) && t.shiftKey;
}, Ct = function(t) {
  return setTimeout(t, 0);
}, ue = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ne = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Ri = [], Ai = function(t, n) {
  var r = n?.document || document, i = n?.trapStack || Ri, a = kt({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Li,
    isKeyBackward: Fi
  }, n), o = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, s, c = function(f, h, b) {
    return f && f[h] !== void 0 ? f[h] : a[b || h];
  }, l = function(f, h) {
    var b = typeof h?.composedPath == "function" ? h.composedPath() : void 0;
    return o.containerGroups.findIndex(function(E) {
      var w = E.container, N = E.tabbableNodes;
      return w.contains(f) || b?.includes(w) || N.find(function(T) {
        return T === f;
      });
    });
  }, d = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = h.hasFallback, E = b === void 0 ? !1 : b, w = h.params, N = w === void 0 ? [] : w, T = a[f];
    if (typeof T == "function" && (T = T.apply(void 0, Ci(N))), T === !0 && (T = void 0), !T) {
      if (T === void 0 || T === !1) return T;
      throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
    }
    var C = T;
    if (typeof T == "string") {
      try {
        C = r.querySelector(T);
      } catch (_) {
        throw new Error("`".concat(f, '` appears to be an invalid selector; error="').concat(_.message, '"'));
      }
      if (!C && !E)
        throw new Error("`".concat(f, "` as selector refers to no known node"));
    }
    return C;
  }, u = function() {
    var f = d("initialFocus", { hasFallback: !0 });
    if (f === !1) return !1;
    if (f === void 0 || f && !Oe(f, a.tabbableOptions)) if (l(r.activeElement) >= 0) f = r.activeElement;
    else {
      var h = o.tabbableGroups[0];
      f = h && h.firstTabbableNode || d("fallbackFocus");
    }
    else f === null && (f = d("fallbackFocus"));
    if (!f) throw new Error("Your focus-trap needs to have at least one focusable element");
    return f;
  }, v = function() {
    if (o.containerGroups = o.containers.map(function(f) {
      var h = wi(f, a.tabbableOptions), b = vn(f, a.tabbableOptions), E = h.length > 0 ? h[0] : void 0, w = h.length > 0 ? h[h.length - 1] : void 0, N = b.find(function(C) {
        return se(C);
      }), T = b.slice().reverse().find(function(C) {
        return se(C);
      });
      return {
        container: f,
        tabbableNodes: h,
        focusableNodes: b,
        posTabIndexesFound: !!h.find(function(C) {
          return te(C) > 0;
        }),
        firstTabbableNode: E,
        lastTabbableNode: w,
        firstDomTabbableNode: N,
        lastDomTabbableNode: T,
        nextTabbableNode: function(_) {
          var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, B = h.indexOf(_);
          return B < 0 ? P ? b.slice(b.indexOf(_) + 1).find(function($) {
            return se($);
          }) : b.slice(0, b.indexOf(_)).reverse().find(function($) {
            return se($);
          }) : h[B + (P ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(f) {
      return f.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !d("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(f) {
      return f.posTabIndexesFound;
    }) && o.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function(f) {
    var h = f.activeElement;
    if (h)
      return h.shadowRoot && h.shadowRoot.activeElement !== null ? p(h.shadowRoot) : h;
  }, g = function(f) {
    if (f !== !1 && f !== p(document)) {
      if (!f || !f.focus) {
        g(u());
        return;
      }
      f.focus({ preventScroll: !!a.preventScroll }), o.mostRecentlyFocusedNode = f, Ii(f) && f.select();
    }
  }, y = function(f) {
    var h = d("setReturnFocus", { params: [f] });
    return h || (h === !1 ? !1 : f);
  }, m = function(f) {
    var h = f.target, b = f.event, E = f.isBackward, w = E === void 0 ? !1 : E;
    h = h || Ne(b), v();
    var N = null;
    if (o.tabbableGroups.length > 0) {
      var T = l(h, b), C = T >= 0 ? o.containerGroups[T] : void 0;
      if (T < 0) w ? N = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : N = o.tabbableGroups[0].firstTabbableNode;
      else if (w) {
        var _ = o.tabbableGroups.findIndex(function(Ge) {
          var Ye = Ge.firstTabbableNode;
          return h === Ye;
        });
        if (_ < 0 && (C.container === h || Oe(h, a.tabbableOptions) && !se(h, a.tabbableOptions) && !C.nextTabbableNode(h, !1)) && (_ = T), _ >= 0) {
          var P = _ === 0 ? o.tabbableGroups.length - 1 : _ - 1, B = o.tabbableGroups[P];
          N = te(h) >= 0 ? B.lastTabbableNode : B.lastDomTabbableNode;
        } else pe(b) || (N = C.nextTabbableNode(h, !1));
      } else {
        var $ = o.tabbableGroups.findIndex(function(Ge) {
          var Ye = Ge.lastTabbableNode;
          return h === Ye;
        });
        if ($ < 0 && (C.container === h || Oe(h, a.tabbableOptions) && !se(h, a.tabbableOptions) && !C.nextTabbableNode(h)) && ($ = T), $ >= 0) {
          var Ke = $ === o.tabbableGroups.length - 1 ? 0 : $ + 1, J = o.tabbableGroups[Ke];
          N = te(h) >= 0 ? J.firstTabbableNode : J.firstDomTabbableNode;
        } else pe(b) || (N = C.nextTabbableNode(h));
      }
    } else N = d("fallbackFocus");
    return N;
  }, x = function(f) {
    if (!(l(Ne(f), f) >= 0)) {
      if (ue(a.clickOutsideDeactivates, f)) {
        s.deactivate({ returnFocus: a.returnFocusOnDeactivate });
        return;
      }
      ue(a.allowOutsideClick, f) || f.preventDefault();
    }
  }, O = function(f) {
    var h = Ne(f), b = l(h, f) >= 0;
    if (b || h instanceof Document)
      b && (o.mostRecentlyFocusedNode = h);
    else {
      f.stopImmediatePropagation();
      var E, w = !0;
      if (o.mostRecentlyFocusedNode)
        if (te(o.mostRecentlyFocusedNode) > 0) {
          var N = l(o.mostRecentlyFocusedNode), T = o.containerGroups[N].tabbableNodes;
          if (T.length > 0) {
            var C = T.findIndex(function(_) {
              return _ === o.mostRecentlyFocusedNode;
            });
            C >= 0 && (a.isKeyForward(o.recentNavEvent) ? C + 1 < T.length && (E = T[C + 1], w = !1) : C - 1 >= 0 && (E = T[C - 1], w = !1));
          }
        } else o.containerGroups.some(function(_) {
          return _.tabbableNodes.some(function(P) {
            return te(P) > 0;
          });
        }) || (w = !1);
      else w = !1;
      w && (E = m({
        target: o.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(o.recentNavEvent)
      })), g(E || o.mostRecentlyFocusedNode || u());
    }
    o.recentNavEvent = void 0;
  }, I = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = f;
    var b = m({
      event: f,
      isBackward: h
    });
    b && (pe(f) && f.preventDefault(), g(b));
  }, A = function(f) {
    (a.isKeyForward(f) || a.isKeyBackward(f)) && I(f, a.isKeyBackward(f));
  }, F = function(f) {
    _i(f) && ue(a.escapeDeactivates, f) !== !1 && (f.preventDefault(), s.deactivate());
  }, D = function(f) {
    l(Ne(f), f) >= 0 || ue(a.clickOutsideDeactivates, f) || ue(a.allowOutsideClick, f) || (f.preventDefault(), f.stopImmediatePropagation());
  }, k = function() {
    if (!o.active) return Promise.resolve();
    K.activateTrap(i, s);
    var f;
    return a.delayInitialFocus ? f = new Promise(function(h) {
      o.delayInitialFocusTimer = Ct(function() {
        g(u()), h();
      });
    }) : (f = Promise.resolve(), g(u())), r.addEventListener("focusin", O, !0), r.addEventListener("mousedown", x, {
      capture: !0,
      passive: !1
    }), r.addEventListener("touchstart", x, {
      capture: !0,
      passive: !1
    }), r.addEventListener("click", D, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", A, {
      capture: !0,
      passive: !1
    }), r.addEventListener("keydown", F), f;
  }, L = function(f) {
    o.active && !o.paused && s._setSubtreeIsolation(!1), o.adjacentElements.clear(), o.alreadySilent.clear();
    var h = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), E = St(f), w;
    try {
      for (E.s(); !(w = E.n()).done; ) {
        var N = w.value;
        h.add(N);
        for (var T = typeof ShadowRoot < "u" && N.getRootNode() instanceof ShadowRoot, C = N; C; ) {
          h.add(C);
          var _ = C.parentElement, P = [];
          _ ? P = _.children : !_ && T && (P = C.getRootNode().children, _ = C.getRootNode().host, T = typeof ShadowRoot < "u" && _.getRootNode() instanceof ShadowRoot);
          var B = St(P), $;
          try {
            for (B.s(); !($ = B.n()).done; ) {
              var Ke = $.value;
              b.add(Ke);
            }
          } catch (J) {
            B.e(J);
          } finally {
            B.f();
          }
          C = _;
        }
      }
    } catch (J) {
      E.e(J);
    } finally {
      E.f();
    }
    h.forEach(function(J) {
      b.delete(J);
    }), o.adjacentElements = b;
  }, U = function() {
    if (o.active)
      return r.removeEventListener("focusin", O, !0), r.removeEventListener("mousedown", x, !0), r.removeEventListener("touchstart", x, !0), r.removeEventListener("click", D, !0), r.removeEventListener("keydown", A, !0), r.removeEventListener("keydown", F), s;
  }, z = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(f) {
    f.some(function(h) {
      return Array.from(h.removedNodes).some(function(b) {
        return b === o.mostRecentlyFocusedNode;
      });
    }) && g(u());
  }) : void 0, M = function() {
    z && (z.disconnect(), o.active && !o.paused && o.containers.map(function(f) {
      z.observe(f, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(f) {
      if (o.active) return this;
      var h = c(f, "onActivate"), b = c(f, "onPostActivate"), E = c(f, "checkCanFocusTrap"), w = K.getActiveTrap(i), N = !1;
      if (w && !w.paused) {
        var T;
        (T = w._setSubtreeIsolation) === null || T === void 0 || T.call(w, !1), N = !0;
      }
      try {
        E || v(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = p(r), h?.();
        var C = /* @__PURE__ */ (function() {
          var P = Et(/* @__PURE__ */ ve().m(function B() {
            return ve().w(function($) {
              for (; ; ) switch ($.n) {
                case 0:
                  return E && v(), $.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), M(), b?.();
                case 2:
                  return $.a(2);
              }
            }, B);
          }));
          return function() {
            return P.apply(this, arguments);
          };
        })();
        if (E)
          return E(o.containers.concat()).then(C, C), this;
        C();
      } catch (P) {
        if (w === K.getActiveTrap(i) && N) {
          var _;
          (_ = w._setSubtreeIsolation) === null || _ === void 0 || _.call(w, !0);
        }
        throw P;
      }
      return this;
    },
    deactivate: function(f) {
      if (!o.active) return this;
      var h = kt({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, f);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, o.paused || s._setSubtreeIsolation(!1), o.alreadySilent.clear(), U(), o.active = !1, o.paused = !1, M(), K.deactivateTrap(i, s);
      var b = c(h, "onDeactivate"), E = c(h, "onPostDeactivate"), w = c(h, "checkCanReturnFocus"), N = c(h, "returnFocus", "returnFocusOnDeactivate");
      b?.();
      var T = function() {
        Ct(function() {
          N && g(y(o.nodeFocusedBeforeActivation)), E?.();
        });
      };
      return N && w ? (w(y(o.nodeFocusedBeforeActivation)).then(T, T), this) : (T(), this);
    },
    pause: function(f) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, f)) : this;
    },
    unpause: function(f) {
      return o.active ? (o.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, f)) : this;
    },
    updateContainerElements: function(f) {
      return o.containers = [].concat(f).filter(Boolean).map(function(h) {
        return typeof h == "string" ? r.querySelector(h) : h;
      }), a.isolateSubtrees && L(o.containers), o.active && (v(), o.paused || s._setSubtreeIsolation(!0)), M(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: { value: function() {
      return o.manuallyPaused;
    } },
    _setPausedState: { value: function(f, h) {
      if (o.paused === f) return this;
      if (o.paused = f, f) {
        var b = c(h, "onPause"), E = c(h, "onPostPause");
        b?.(), U(), s._setSubtreeIsolation(!1), M(), E?.();
      } else {
        var w = c(h, "onUnpause"), N = c(h, "onPostUnpause");
        w?.(), (/* @__PURE__ */ (function() {
          var T = Et(/* @__PURE__ */ ve().m(function C() {
            return ve().w(function(_) {
              for (; ; ) switch (_.n) {
                case 0:
                  return v(), _.n = 1, k();
                case 1:
                  s._setSubtreeIsolation(!0), M(), N?.();
                case 2:
                  return _.a(2);
              }
            }, C);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(f) {
      a.isolateSubtrees && o.adjacentElements.forEach(function(h) {
        var b;
        f ? a.isolateSubtrees === "aria-hidden" ? ((h.ariaHidden === "true" || ((b = h.getAttribute("aria-hidden")) === null || b === void 0 ? void 0 : b.toLowerCase()) === "true") && o.alreadySilent.add(h), h.setAttribute("aria-hidden", "true")) : ((h.inert || h.hasAttribute("inert")) && o.alreadySilent.add(h), h.setAttribute("inert", !0)) : o.alreadySilent.has(h) || (a.isolateSubtrees === "aria-hidden" ? h.removeAttribute("aria-hidden") : h.removeAttribute("inert"));
      });
    } }
  }), s.updateContainerElements(t), s;
};
function Di(e) {
  let t, n;
  window.addEventListener("focusin", () => {
    t = n, n = document.activeElement;
  }), e.magic("focus", (r) => {
    let i = r;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(a) {
        return i = a, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(a) {
        return Oe(a);
      },
      previouslyFocused() {
        return t;
      },
      lastFocused() {
        return t;
      },
      focused() {
        return n;
      },
      focusables() {
        return Array.isArray(i) ? i : vn(i, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(a) {
        let o = this.all();
        return o[0] && o[0].isSameNode(a);
      },
      isLast(a) {
        let o = this.all();
        return o.length && o.slice(-1)[0].isSameNode(a);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === a.length - 1 ? a[0] : a[a.indexOf(o) + 1];
      },
      getPrevious() {
        let a = this.all(), o = document.activeElement;
        if (a.indexOf(o) !== -1)
          return this.__wrapAround && a.indexOf(o) === 0 ? a.slice(-1)[0] : a[a.indexOf(o) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(a) {
        a && setTimeout(() => {
          a.hasAttribute("tabindex") || a.setAttribute("tabindex", "0"), a.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), e.directive("trap", e.skipDuringClone((r, { expression: i, modifiers: a }, { effect: o, evaluateLater: s, cleanup: c }) => {
    let l = s(i), d = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => r
    }, v = () => {
    };
    if (a.includes("noautofocus")) u.initialFocus = !1;
    else {
      let m = r.querySelector("[autofocus]");
      m && (u.initialFocus = m);
    }
    a.includes("inert") && (u.onPostActivate = () => {
      e.nextTick(() => {
        v = Nt(r);
      });
    });
    let p = Ai(r, u), g = () => {
    };
    const y = () => {
      v(), v = () => {
      }, g(), g = () => {
      }, p.deactivate({ returnFocus: !a.includes("noreturn") });
    };
    o(() => l((m) => {
      d !== m && (m && !d && (a.includes("noscroll") && (g = $i()), setTimeout(() => {
        p.activate();
      }, 15)), !m && d && y(), d = !!m);
    })), c(y);
  }, (r, { expression: i, modifiers: a }, { evaluate: o }) => {
    a.includes("inert") && o(i) && Nt(r);
  }));
}
function Nt(e) {
  let t = [];
  return mn(e, (n) => {
    let r = n.hasAttribute("aria-hidden");
    n.setAttribute("aria-hidden", "true"), t.push(() => r || n.removeAttribute("aria-hidden"));
  }), () => {
    for (; t.length; ) t.pop()();
  };
}
function mn(e, t) {
  e.isSameNode(document.body) || !e.parentNode || Array.from(e.parentNode.children).forEach((n) => {
    n.isSameNode(e) ? mn(e.parentNode, t) : t(n);
  });
}
function $i() {
  let e = document.documentElement.style.overflow, t = document.documentElement.style.paddingRight, n = window.innerWidth - document.documentElement.clientWidth, r = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", r && r !== "auto" ? () => {
    document.documentElement.style.overflow = e;
  } : (document.documentElement.style.paddingRight = `${n}px`, () => {
    document.documentElement.style.overflow = e, document.documentElement.style.paddingRight = t;
  });
}
var Mi = Di;
function Pi(e) {
  e.directive("intersect", e.skipDuringClone((t, { value: n, expression: r, modifiers: i }, { evaluateLater: a, cleanup: o }) => {
    let s = a(r), c = {
      rootMargin: Hi(i),
      threshold: ji(i)
    }, l = new IntersectionObserver((d) => {
      d.forEach((u) => {
        u.isIntersecting !== (n === "leave") && (s(), i.includes("once") && l.disconnect());
      });
    }, c);
    l.observe(t), o(() => {
      l.disconnect();
    });
  }));
}
function ji(e) {
  if (e.includes("full")) return 0.99;
  if (e.includes("half")) return 0.5;
  if (!e.includes("threshold")) return 0;
  let t = e[e.indexOf("threshold") + 1];
  return t === "100" ? 1 : t === "0" ? 0 : +`.${t}`;
}
function Bi(e) {
  let t = e.match(/^(-?[0-9]+)(px|%)?$/);
  return t ? t[1] + (t[2] || "px") : void 0;
}
function Hi(e) {
  const t = "margin", n = "0px 0px 0px 0px", r = e.indexOf(t);
  if (r === -1) return n;
  let i = [];
  for (let a = 1; a < 5; a++) i.push(Bi(e[r + a] || ""));
  return i = i.filter((a) => a !== void 0), i.length ? i.join(" ").trim() : n;
}
var Vi = Pi;
function ot(e, t, n) {
  bn();
  let r = gn(n), i = typeof t == "string" ? Wi(t) : t;
  return window.Alpine && window.Alpine.closestDataStack && !e._x_dataStack && (i._x_dataStack = window.Alpine.closestDataStack(e), i._x_dataStack && window.Alpine.cloneNode(e, i)), r.patch(e, i), e;
}
function qi(e, t, n, r = {}) {
  bn();
  let i = gn(r), a = e.parentNode, o = new ge(e, t), s = typeof n == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", n), u;
  })() : n, c = document.createComment("[morph-start]"), l = document.createComment("[morph-end]");
  s.insertBefore(c, s.firstChild), s.appendChild(l);
  let d = new ge(c, l);
  window.Alpine && window.Alpine.closestDataStack && (s._x_dataStack = window.Alpine.closestDataStack(a), s._x_dataStack && window.Alpine.cloneNode(a, s)), i.patchChildren(o, d);
}
function gn(e = {}) {
  let t = (i) => i.getAttribute("key"), n = () => {
  }, r = {
    key: e.key || t,
    lookahead: e.lookahead || !1,
    updating: e.updating || n,
    updated: e.updated || n,
    removing: e.removing || n,
    removed: e.removed || n,
    adding: e.adding || n,
    added: e.added || n
  };
  return r.patch = function(i, a) {
    if (r.differentElementNamesTypesOrKeys(i, a)) return r.swapElements(i, a);
    let o = !1, s = !1, c = (l) => r.skipUntilCondition = l;
    if (!Ui(r.updating, () => s = !0, c, i, a, () => o = !0)) {
      if (i.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(i, a), i._x_teleport && a._x_teleport && r.patch(i._x_teleport, a._x_teleport)), zi(a)) {
        r.patchNodeValue(i, a), r.updated(i, a);
        return;
      }
      o || r.patchAttributes(i, a), r.updated(i, a), s || r.patchChildren(i, a);
    }
  }, r.differentElementNamesTypesOrKeys = function(i, a) {
    return i.nodeType != a.nodeType || i.nodeName != a.nodeName || r.getKey(i) != r.getKey(a);
  }, r.swapElements = function(i, a) {
    if (de(r.removing, i)) return;
    let o = a.cloneNode(!0);
    de(r.adding, o) || (i.replaceWith(o), r.removed(i), r.added(o));
  }, r.patchNodeValue = function(i, a) {
    let o = a.nodeValue;
    i.nodeValue !== o && (i.nodeValue = o);
  }, r.patchAttributes = function(i, a) {
    if (i._x_transitioning || i._x_isShown && !a._x_isShown || !i._x_isShown && a._x_isShown) return;
    let o = Array.from(i.attributes), s = Array.from(a.attributes);
    for (let c = o.length - 1; c >= 0; c--) {
      let l = o[c].name;
      a.hasAttribute(l) || (l === "open" && i.nodeName === "DIALOG" && i.open ? i.close() : i.removeAttribute(l));
    }
    for (let c = s.length - 1; c >= 0; c--) {
      let l = s[c].name, d = s[c].value;
      i.getAttribute(l) !== d && i.setAttribute(l, d);
    }
  }, r.patchChildren = function(i, a) {
    let o = r.keyToMap(i.children), s = {}, c = It(a), l = It(i);
    for (; c; ) {
      Ki(c, l);
      let u = r.getKey(c), v = r.getKey(l);
      if (r.skipUntilCondition) {
        let m = !l || r.skipUntilCondition(l), x = !c || r.skipUntilCondition(c);
        if (m && x) r.skipUntilCondition = null;
        else {
          m || (l = l && j(i, l)), x || (c = c && j(a, c));
          continue;
        }
      }
      if (!l) if (u && s[u]) {
        let m = s[u];
        i.appendChild(m), l = m, v = r.getKey(l);
      } else {
        if (!de(r.adding, c)) {
          let m = c.cloneNode(!0);
          i.appendChild(m), r.added(m);
        }
        c = j(a, c);
        continue;
      }
      let p = (m) => m && m.nodeType === 8 && m.textContent === "[if BLOCK]><![endif]", g = (m) => m && m.nodeType === 8 && m.textContent === "[if ENDBLOCK]><![endif]";
      if (p(c) && p(l)) {
        let m = 0, x = l;
        for (; l; ) {
          let k = j(i, l);
          if (p(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            l = k;
            break;
          }
          l = k;
        }
        let O = l;
        m = 0;
        let I = c;
        for (; c; ) {
          let k = j(a, c);
          if (p(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            c = k;
            break;
          }
          c = k;
        }
        let A = c, F = new ge(x, O), D = new ge(I, A);
        r.patchChildren(F, D);
        continue;
      }
      if (l.nodeType === 1 && r.lookahead && !l.isEqualNode(c)) {
        let m = j(a, c), x = !1;
        for (; !x && m; )
          m.nodeType === 1 && l.isEqualNode(m) && (x = !0, l = r.addNodeBefore(i, c, l), v = r.getKey(l)), m = j(a, m);
      }
      if (u !== v) {
        if (!u && v) {
          s[v] = l, l = r.addNodeBefore(i, c, l), s[v].remove(), l = j(i, l), c = j(a, c);
          continue;
        }
        if (u && !v && o[u] && (l.replaceWith(o[u]), l = o[u], v = r.getKey(l)), u && v) {
          let m = o[u];
          if (m)
            s[v] = l, l.replaceWith(m), l = m, v = r.getKey(l);
          else {
            s[v] = l, l = r.addNodeBefore(i, c, l), s[v].remove(), l = j(i, l), c = j(a, c);
            continue;
          }
        }
      }
      let y = l && j(i, l);
      r.patch(l, c), c = c && j(a, c), l = y;
    }
    let d = [];
    for (; l; )
      de(r.removing, l) || d.push(l), l = j(i, l);
    for (; d.length; ) {
      let u = d.shift();
      u.remove(), r.removed(u);
    }
  }, r.getKey = function(i) {
    return i && i.nodeType === 1 && r.key(i);
  }, r.keyToMap = function(i) {
    let a = {};
    for (let o of i) {
      let s = r.getKey(o);
      s && (a[s] = o);
    }
    return a;
  }, r.addNodeBefore = function(i, a, o) {
    if (!de(r.adding, a)) {
      let s = a.cloneNode(!0);
      return i.insertBefore(s, o), r.added(s), s;
    }
    return a;
  }, r;
}
ot.step = () => {
};
ot.log = () => {
};
function de(e, ...t) {
  let n = !1;
  return e(...t, () => n = !0), n;
}
function Ui(e, t, n, ...r) {
  let i = !1;
  return e(...r, () => i = !0, t, n), i;
}
var Ot = !1;
function Wi(e) {
  const t = document.createElement("template");
  return t.innerHTML = e, t.content.firstElementChild;
}
function zi(e) {
  return e.nodeType === 3 || e.nodeType === 8;
}
var ge = class {
  constructor(e, t) {
    this.startComment = e, this.endComment = t;
  }
  get children() {
    let e = [], t = this.startComment.nextSibling;
    for (; t && t !== this.endComment; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  appendChild(e) {
    this.endComment.before(e);
  }
  get firstChild() {
    let e = this.startComment.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  nextNode(e) {
    let t = e.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  insertBefore(e, t) {
    return t.before(e), e;
  }
};
function It(e) {
  return e.firstChild;
}
function j(e, t) {
  let n;
  return e instanceof ge ? n = e.nextNode(t) : n = t.nextSibling, n;
}
function bn() {
  if (Ot) return;
  Ot = !0;
  let e = Element.prototype.setAttribute, t = document.createElement("div");
  Element.prototype.setAttribute = function(r, i) {
    if (!r.includes("@")) return e.call(this, r, i);
    t.innerHTML = `<span ${r}="${i.replace(/&/g, "&amp;").replace(/"/g, "&quot;")}"></span>`;
    let a = t.firstElementChild.getAttributeNode(r);
    t.firstElementChild.removeAttributeNode(a), this.setAttributeNode(a);
  };
}
function Ki(e, t) {
  let n = t && t._x_bindings && t._x_bindings.id;
  n && e.setAttribute && (e.setAttribute("id", n), e.id = n);
}
function Gi(e) {
  e.morph = ot, e.morphBetween = qi;
}
var Yi = Gi, Ji = (e, t) => {
  let n;
  const r = /* @__PURE__ */ new Set();
  return function(i, a) {
    n && clearTimeout(n), i.forEach(({ target: o }) => r.add(o)), n = setTimeout(() => {
      e(r, a), n = null;
    }, t);
  };
}, Xi = (e) => {
  e.forEach((t) => Zi(t)), e.clear();
}, Zi = (e) => {
  const t = (o) => e.setAttribute("sizes", (o | 0) + "px");
  let n = 0, r = 0, i = e;
  for (; n < 100 && i; )
    n = i.offsetWidth, r = i.offsetHeight, i = i.parentNode;
  if (getComputedStyle(e).objectFit !== "cover") return t(n);
  const a = Number(e.getAttribute("width")) / Number(e.getAttribute("height"));
  if (!a || n / r >= a + 0.1) return t(n);
  t(r * a);
}, Q = new ResizeObserver(Ji(Xi, 800)), _t = (e, t, n) => {
  if (t) return ea(e);
  if (n) return Qi(e, n);
  throw new TypeError("Invalid options");
}, Qi = (e, t) => (e = new URL(e, document.baseURI).href, e.includes("localhost") ? () => e : (n) => (t + e).replace("{width}", String(n))), ea = (e) => {
  if (e.includes("{width}")) return (t) => e.replaceAll("{width}", String(t));
  if (Ft.test(e)) {
    const t = e.replace(Ft, "_{width}x$1");
    return (n) => t.replaceAll("{width}", String(n));
  }
  return (t) => {
    const n = new URL(e, document.baseURI);
    return n.searchParams.set("width", String(t)), n.href;
  };
}, ta = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], Lt = (e, t = 1 / 0) => ta.filter((n) => n <= t).map((n) => `${e(n)} ${n}w`).join(","), Ft = /_\d+x(\.jpg|\.png)/;
function na(e) {
  const { autoSize: t = !0, shopify: n = !1, maxSize: r = 0, cloudURL: i = "" } = ra(e) ?? {};
  return (a) => {
    a.directive("rias", (s, { expression: c }, { effect: l, evaluateLater: d, cleanup: u }) => {
      if (!(s instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => Q.unobserve(s)), !c) return t && Q.observe(s);
      const v = d(c);
      l(() => {
        v((p) => {
          if (!p || typeof p != "string") return;
          const g = _t(p, n, i), y = r || Number(s.dataset.maxSize) || 1 / 0, m = g(Math.min(y, 360)), x = Lt(g, y);
          a.mutateDom(() => {
            s.src = m, s.srcset = x, s.loading = s.loading == "eager" ? "eager" : "lazy", (t || s.dataset.sizes == "auto") && Q.observe(s);
          });
        });
      });
    });
    const o = {
      srcset(s) {
        return Lt(_t(s, n, i), r || 1 / 0);
      },
      observe: Q.observe.bind(Q),
      unobserve: Q.unobserve.bind(Q)
    };
    a.magic("rias", () => o);
  };
}
var ra = (e) => {
  if (typeof e == "string") return { cloudURL: `https://res.cloudinary.com/${e}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof e == "object") return {
    ...e,
    cloudURL: e.key ? `https://res.cloudinary.com/${e.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, ia = (e) => {
  e.addRootSelector(() => `[${e.prefixed("data-async")}]`);
  const t = "data-async", n = e.prefixed("ignore"), r = {}, i = /* @__PURE__ */ new WeakSet(), a = (o, { expression: s }, { evaluateLater: c, evaluate: l, cleanup: d }) => {
    i.has(o) || (i.add(o), c(s)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const v = e.reactive(u), p = e.addScopeToNode(o, v);
      v.init && l(v.init), d(() => {
        v.destroy && l(v.destroy), p();
      }), delete o._x_ignore, o.removeAttribute(n), e.initTree(o);
    }, { scope: r }));
  };
  a.inline = (o, { expression: s }) => {
    i.has(o) || (o._x_ignore = !0, o.setAttribute(n, ""));
  }, e.directive(t, a).before("ignore"), e.asyncData = (o, s) => {
    r[o] = async (...c) => {
      const [l, d] = s.split("?");
      try {
        const u = await import(l);
        if (d && d in u) return u[d](...c);
        if (o in u) return u[o](...c);
        if (u.default && typeof u.default == "function") return u.default(...c);
        if (typeof u == "function") return u(...c);
        throw new Error(`Async Data: Module ${s} does not export a function named ${o}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", o, s), console.error(u), {};
      }
    };
  };
}, aa = (e) => {
  e.directive("clickable", (r, { expression: i }, { cleanup: a }) => {
    const o = r.querySelector(i || "a, button");
    if (!o) return console.warn(`x-clickable: No target found for selector ${i || "a, button"}`);
    const s = function(c) {
      const l = c.target;
      !(l instanceof HTMLElement) || t(l, r) !== r || n(o, c.constructor, c);
    };
    a(e.bind(r, {
      "@click": s,
      "@auxclick": s
    }));
  });
  const t = (r, i) => e.findClosest(r, (a) => a.matches("a, button, input, select") || a === i), n = (r, i = MouseEvent, a) => r.dispatchEvent(new i("click", a));
}, oa = class {
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(e, t, n) {
    this.el = e, this.details = n, this.backdrop = t.backdrop, this.keyboard = t.keyboard;
  }
  withDetails(e) {
    return e && (this.details = e), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, sa = class extends EventTarget {
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(e) {
    super(), this.Alpine = e;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(e, t) {
    if (e === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const n = this.availableDialogs.get(e) ?? null;
    return n ? (this.active = n, n.withDetails(t).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: n })), this) : (console.error(`Modal with id "${e}" does not exist`), this);
  }
  close(e) {
    const t = e ?? this.active;
    return t ? (t.close().then((n) => n === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: t })), this) : (console.log(e, t, "there is no active"), this);
  }
  setOptions(e) {
    return this.active && Object.assign(this.active, e), this;
  }
  isRegistered(e) {
    return this.availableDialogs.has(e);
  }
  unregister(e) {
    return this.availableDialogs.delete(e), this.active?.id === e && (this.active = null), this;
  }
  create(e, t, n) {
    const r = this.Alpine.reactive(new oa(e, t, n));
    return this.availableDialogs.set(r.id, r), r;
  }
}, ca = (e) => {
  const t = new sa(e);
  e.addRootSelector(() => `[${e.prefixed("dialog")}]`), e.directive("dialog", (n, { expression: r }, { evaluate: i, cleanup: a }) => {
    if (!(n instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", n);
    const o = n.id;
    console.assert(!!o, "x-dialog element must have an ID: %o", n);
    const { backdrop: s = !0, keyboard: c = !0 } = r ? i(r) : {}, l = t.create(n, {
      backdrop: s,
      keyboard: c
    });
    a(e.addScopeToNode(n, { $dialog: l })), a(t.unregister.bind(t, o)), a(e.bind(n, {
      "@click.self"() {
        l.backdrop && t.close(l);
      },
      "@cancel.prevent.stop"() {
        l.keyboard && t.close(l);
      },
      "@dialog-closed.self"(d) {
        d.detail === l && l === t.active && (t.active = null, t.dispatchEvent(new CustomEvent("dialog-closed", { detail: l })));
      },
      "@keydown.escape.prevent.stop"() {
        l.keyboard && t.close(l);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": l.closing,
          "dialog-in backdrop:animate-fade-in": l.opening
        };
      }
    }));
  }), e.magic("dialogs", () => t), e.$dialogs = t;
}, Ie = /* @__PURE__ */ (function(e) {
  return e.Up = "up", e.Down = "down", e;
})(Ie || {}), la = (e) => {
  const t = /* @__PURE__ */ new Set(), n = e.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Ie.Up,
    onScroll: (i) => (t.add(i), () => t.delete(i))
  });
  let r;
  n.onScroll((i) => {
    const a = i.current > i.previous ? Ie.Down : Ie.Up;
    a !== n.direction ? r ??= setTimeout(() => n.direction = a, 200) : (clearTimeout(r), r = void 0);
  }), window.addEventListener("scroll", () => {
    n.previous = n.current, n.current = window.scrollY, n.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : n.nearTop, t.forEach((i) => i(n));
  }, { passive: !0 }), e.$scroll = n, e.magic("scroll", () => n);
}, R = /* @__PURE__ */ Symbol("$slider"), yn = (e) => R in e, ua = {
  ":disabled"() {
    return this[R].isLast;
  },
  "x-on:click"() {
    this[R].next(this.$el);
  }
}, da = {
  ":disabled"() {
    return this[R].isFirst;
  },
  "x-on:click"() {
    this[R].prev(this.$el);
  }
}, fa = (e) => ({
  ":disabled"() {
    return this[R].focusedIndex === e;
  },
  "x-on:click"() {
    this[R].scrollTo(e);
  }
}), ha = {
  "x-on:mouseenter"() {
    this[R].pause();
  },
  "x-on:mouseleave"() {
    this[R].unpause();
  },
  "x-on:focusin"() {
    this[R].pause();
  },
  "x-on:focusout"() {
    this[R].unpause();
  }
}, va = { ":style"() {
  const e = this[R].focusedSize;
  return {
    maxHeight: e ? `${e}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, pa = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const e = this[R];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const e = this[R];
    this.index = e.indexOfItem(this.$el) ?? 0, e.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[R].onLoad(this.$el);
  },
  "x-on:load"() {
    this[R].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const e = this[R], t = this.index, n = e.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": t > n,
      "slide-previous": t < n,
      "slide-current": t === n,
      "slide-visible": this.visible
    };
  }
}, ma = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, ga = (e, t, n, { Alpine: r, cleanup: i }) => {
  const a = r.$data(t);
  if (!yn(a)) {
    console.error(`Element with ${n.original} needs to be inside an x-slider element`, t);
    return;
  }
  const o = a[R];
  if (o.components.set(e, t), e === "gallery") {
    const s = new AbortController();
    t.addEventListener("scroll", o.updateEdges.bind(o), {
      passive: !0,
      signal: s.signal
    }), i(() => s.abort()), o.updateEdges();
  }
}, ee = (e) => Array.from(e.children).flatMap((t) => getComputedStyle(t).display === "contents" ? ee(t) : t).filter((t) => t.nodeName !== "TEMPLATE" && getComputedStyle(t).display !== "none"), ba = (e, t) => {
  let n = 0, r = Number.POSITIVE_INFINITY;
  for (let i = 0; i < e.length; i++) {
    const a = Math.abs(e[i] - t);
    if (a >= r) return n;
    r = a, n = i;
  }
  return n;
}, ya = (e, t, n, r = 1) => {
  const i = t - n;
  return {
    atStart: e <= r,
    atEnd: e >= i - r
  };
}, wa = (e) => e instanceof HTMLImageElement, xa = (e, { expression: t }, { evaluate: n, cleanup: r, Alpine: i }) => {
  const a = [];
  r(() => a.forEach((c) => c()));
  const o = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, t ? n(t) : {}), s = i.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!o.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (o.autoScroll) {
        const c = new Ea(o.autoScroll).onTick((l) => {
          this.autoScrollPercentage = l;
        }).onFinish(() => {
          if (this.touched) return c.abort();
          if (this.paused) return;
          const l = this.components.get("gallery");
          l && this.scrollTo(Dn(this.focusedIndex + 1, ee(l).length));
        });
        a.push(() => c.abort());
      }
    },
    onLoad(c) {
      if (this.initialized || wa(c) && !c.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const l = this.components.get("gallery");
      l && (l.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(c, l = !0) {
      if (!this.initialized) return;
      const d = this.components.get("gallery");
      if (l && (!d || o.animated)) {
        this.focusedIndex = this.indexOfItem(c) ?? 0, this.focusedSize = c.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const c = this.components.get("gallery");
      if (!c) return;
      const l = ee(c), d = parseFloat(getComputedStyle(c).scrollPaddingLeft) || 0, u = ba(l.map((v) => oe(HTMLElement, v)?.offsetLeft ?? 0), c.scrollLeft + d);
      this.focusedIndex = u, this.focusedSize = oe(HTMLElement, l[u])?.clientHeight ?? e.clientHeight;
    },
    itemAtIndex(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const d = ee(l);
      let u = d[Fn(c, d.length - 1)];
      if (u !== void 0) {
        for (let v = 0; v < o.scrollToDepth; v++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(c + 1) : u;
      }
    },
    indexOfItem(c) {
      const l = this.components.get("gallery");
      if (!l) return;
      const d = ee(l);
      for (let u = 0; u < d.length; u++) if (d[u].contains(c)) return u;
    },
    async scrollTo(c, l = 0, d = !1, u = !1) {
      const v = this.components.get("gallery");
      if (!v) return;
      const p = c instanceof Element ? c : this.itemAtIndex(c);
      if (!p) return;
      d && (this.touched = !0);
      const g = typeof c == "number" ? c : this.indexOfItem(p) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await An()), u || o.animated ? this.focusedIndex = g : this.focusedIndex += Math.sign(g - this.focusedIndex), o.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), o.intoView ? p.scrollIntoView({
        behavior: "smooth",
        block: o.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (v.style.scrollBehavior = "auto"), v.scrollLeft = c === 0 ? 0 : (oe(HTMLElement, p)?.offsetLeft ?? 0) - l, u && (v.style.scrollBehavior = null)));
      const y = this.components.get("thumbnails");
      if (!y) return;
      const m = oe(HTMLElement, y.children[g]);
      m && y.scrollTo({
        top: m.offsetTop - (y.clientHeight - m.clientHeight) / 2,
        left: m.offsetLeft - (y.clientWidth - m.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const c = this.components.get("gallery");
      if (!c || o.animated) return;
      const { atStart: l, atEnd: d } = ya(c.scrollLeft, c.scrollWidth, c.clientWidth);
      this.atStart = l, this.atEnd = d;
    },
    get isFirst() {
      return o.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const c = this.components.get("gallery");
      return c ? o.animated ? this.focusedIndex === ee(c).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const c = this.components.get("gallery");
      return c ? ee(c).length : 0;
    },
    next(c) {
      const l = this.getStepInfo(c);
      this.scrollTo(Math.max(0, this.focusedIndex + l), 10, !0);
    },
    prev(c) {
      const l = this.getStepInfo(c);
      this.scrollTo(Math.max(0, this.focusedIndex - l), 10, !0);
    },
    getStepInfo(c) {
      const l = getComputedStyle(c);
      let d = parseInt(l.getPropertyValue("--perpage") || "1");
      const u = l.getPropertyValue("--arrow-step").trim(), v = this.components.get("gallery");
      if (v && u === "view") {
        const p = oe(HTMLElement, this.itemAtIndex(0)), g = oe(HTMLElement, this.itemAtIndex(1)), y = p && g && p !== g ? Math.abs(g.offsetLeft - p.offsetLeft) : 0;
        y > 0 && (d = Math.max(1, Math.floor(v.clientWidth / y)));
      }
      return d;
    }
  });
  i.addScopeToNode(e, { [R]: s }), o.autoInitialize && s.init();
}, Ea = class wn extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(t) {
    super(), this.duration = t, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (t) => {
    if (this.controller.signal.aborted) return;
    const n = t - this.lastTimestep;
    this.lastTimestep = t, this.currentTime += n, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(t) {
    return this.addEventListener("tick", () => t(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(t) {
    return this.addEventListener("just-finished", t, { signal: this.controller.signal }), this;
  }
  static fromSeconds(t) {
    return new wn(t * 1e3);
  }
}, Sa = (e) => {
  e.addRootSelector(() => `[${e.prefixed("slider")}]`), e.directive("slider", (t, n, r) => {
    if (!n.value || n.value === "root") return xa(t, n, r);
    (n.value === "gallery" || n.value === "thumbnails") && ga(n.value, t, n, r);
  }), e.magic("slider", (t) => {
    const n = e.$data(t);
    if (yn(n)) return n[R];
  }), e.bind("$sliderDynamicHeight", va), e.bind("$sliderItem", pa), e.bind("$sliderNext", ua), e.bind("$sliderPrev", da), e.bind("$sliderGoTo", fa), e.bind("$sliderPause", ha), e.bind("$sliderUnfocusHidden", ma);
}, Rt = (e, t, n = t) => {
  const { scrollPaddingTop: r, scrollPaddingBottom: i } = window.getComputedStyle(e);
  return {
    top: At(r, t),
    bottom: At(i, n)
  };
}, At = (e, t) => e !== "auto" ? parseInt(e) : t, Ta = 100, ka = (e) => {
  e.addRootSelector(() => `[${e.prefixed("smartstick")}]`), e.directive("smartstick", (t, n, { cleanup: r }) => {
    let i = Rt(t, Ta);
    const a = e.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + i.top}px`;
      }
    });
    let o = 0, s = window.scrollY;
    const c = () => {
      const g = window.scrollY, y = g - s;
      a.top = Math.min(o, Math.max(0, a.top + y)), s = g;
    }, l = () => {
      i = Rt(t, i.top, i.bottom), o = Math.max(0, t.clientHeight - window.innerHeight + i.top + i.bottom);
    }, d = new ResizeObserver(l);
    d.observe(t), window.addEventListener("resize", l);
    const u = window.matchMedia("(min-width: 1024px)"), v = (g) => window[g.matches ? "addEventListener" : "removeEventListener"]("scroll", c, { passive: !0 });
    u.addEventListener("change", v), v(u);
    const p = e.effect(() => t.style.top = a.topString);
    r(() => {
      e.release(p), d.disconnect(), u.removeEventListener("change", v), window.removeEventListener("resize", l), window.removeEventListener("scroll", c);
    });
  });
}, st = (e, t, n) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (i) => {
    i.addRootSelector(() => `[${i.prefixed(e)}]`);
    const a = (o) => {
      const s = i.findClosest(o, r.has.bind(r));
      if (!s) return console.error(`Could not find root for ${e} component`, o);
      if (s instanceof HTMLElement) return r.get(s);
    };
    i.magic(e, (o) => a(o)), i.directive(e, (o, s, c) => {
      if (!s.value) return r.set(o, t(o, s, c));
      const l = a(o);
      if (!l) return Na(e, o);
      (n?.[s.value] || Ca(e))(l, o, s, c);
    });
  };
}, Ca = (e) => (t, n, r) => {
  console.error(`Alpine ${e}: Invalid directive value`, n, r.original);
}, Na = (e, t) => console.error(`Could not find root for ${e} component`, t), _e = /* @__PURE__ */ new WeakMap(), Oa = (e, t) => {
  const n = t.findClosest(e, _e.has.bind(_e));
  if (n instanceof HTMLElement) return _e.get(n);
}, Ia = (e, t, { Alpine: n, effect: r }) => {
  const i = n.reactive({
    active: null,
    id: 0,
    addAccordion(a) {
      const o = this.id++, s = n.reactive({ active: a });
      return r(() => {
        s.active ? this.active = o : this.active === o && (this.active = null);
      }), r(() => {
        this.active === o ? s.active = !0 : s.active = !1;
      }), s;
    }
  });
  return _e.set(e, i), i;
}, _a = (e) => {
  e.addRootSelector(() => `[${e.prefixed("accordion-group")}]`), e.directive("accordion-group", Ia);
}, La = (e, { modifiers: [t = "closed"] }, { Alpine: n }) => Oa(e, n)?.addAccordion(t === "open") ?? n.reactive({ active: t === "open" }), Fa = {
  open: !0,
  close: !1,
  toggle: null
}, Ra = (e, t, { modifiers: [n = "toggle"] }, { Alpine: r }) => {
  r.bind(t, {
    "x-on:click": () => {
      e.active = Fa[n] ?? !e.active;
    },
    ":aria-expanded": () => e.active
  });
}, Aa = (e, t, n, { Alpine: r }) => {
  r.bind(t, { "x-show": () => e.active });
}, Da = {
  control: Ra,
  container: Aa
}, $a = st("accordion", La, Da), Ma = (e) => {
  _a(e), $a(e);
}, Dt = new ResizeObserver((e) => {
  for (const t of e) {
    const n = t.target;
    n instanceof HTMLElement && Pa(n);
  }
}), Pa = async (e) => {
  await we.nextTick(), e.scrollLeft = (e.scrollWidth - e.clientWidth) / 2, e.scrollTop = (e.scrollHeight - e.clientHeight) / 2;
}, $t = Array.prototype.forEach, ja = (e) => e.directive("dragscroll", (t, { modifiers: n }, { cleanup: r }) => {
  const i = n.includes("center");
  r(Ba(t)), t.classList.add("overscroll-contain", "cursor-grab"), i && ($t.call(t.children, (a) => Dt.observe(a)), r(() => $t.call(t.children, (a) => Dt.unobserve(a))));
}), fe = (e) => {
  e.preventDefault(), e.stopPropagation();
}, Mt = [
  "pointerup",
  "mouseup",
  "touchend"
], Ba = (e) => {
  const t = (i) => {
    fe(i), e.scrollLeft -= i.movementX, e.scrollTop -= i.movementY;
  }, n = async (i) => {
    fe(i), document.removeEventListener("pointermove", t, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), e.classList.add("cursor-grab"), await we.nextTick(), document.removeEventListener("click", fe, !0), Mt.forEach((a) => document.removeEventListener(a, n, { capture: !0 }));
  }, r = (i) => {
    Ha(i) || i.button !== 2 && (fe(i), e.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", t, { capture: !0 }), Mt.forEach((a) => document.addEventListener(a, n, { capture: !0 })), document.addEventListener("click", fe, { capture: !0 }));
  };
  return e.addEventListener("pointerdown", r), () => e.removeEventListener("pointerdown", r);
}, Ha = (e) => e instanceof TouchEvent || e instanceof PointerEvent && e.pointerType === "touch", Va = (e, t, { Alpine: n }) => {
  const r = n.reactive({
    root: e,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return n.bind(e, { "x-id": () => ["x-panel"] }), r;
}, qa = st("panel", Va, {
  summary: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      ":aria-expanded": () => e.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (e, t, n, { Alpine: r }) => {
    r.bind(t, {
      "x-show": () => e.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Ua = st("tabs", (e, t, { Alpine: n, evaluate: r }) => n.reactive({
  activeTab: 0,
  isSelected(i) {
    return this.tabs[this.activeTab] === i;
  },
  tabs: [],
  panels: [],
  $focus: r("$focus")
}), {
  list: (e, t, n, { Alpine: r }) => {
    const i = () => e.$focus.wrap().next(), a = () => e.$focus.wrap().previous();
    r.bind(t, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": a,
      "@keydown.arrow-right.stop.prevent": i,
      "@keydown.arrow-up.stop.prevent": a,
      "@keydown.arrow-down.stop.prevent": i
    });
  },
  tab: (e, t, n, { Alpine: r }) => {
    const i = e.tabs.push(t) - 1, a = () => e.activeTab = i;
    r.bind(t, {
      ":tabindex": () => +(i === e.activeTab) - 1,
      ":aria-selected": () => i === e.activeTab,
      "@click": a,
      "@keydown.space.stop.prevent": a,
      "@keydown.enter.stop.prevent": a
    });
  },
  panel: (e, t, n, { Alpine: r }) => {
    const i = e.panels.push(t) - 1;
    r.bind(t, {
      ":tab-index": () => i !== e.activeTab ? -1 : 0,
      ":aria-hidden": () => i !== e.activeTab,
      ":class"() {
        if (i === e.activeTab) return "panel-current";
        if (i > e.activeTab) return "panel-next";
        if (i < e.activeTab) return "panel-previous";
      }
    });
  }
}), be;
(function(e) {
  e[e.None = 0] = "None", e[e.Left = 1] = "Left", e[e.Right = 2] = "Right", e[e.Up = 4] = "Up", e[e.Down = 8] = "Down";
})(be || (be = {}));
var ye = /* @__PURE__ */ new WeakMap(), Wa = ye.has.bind(ye), za = (e) => e.directive("swipe", (t, n, { cleanup: r }) => {
  ye.set(t, { dispatch: (i) => {
    const a = Object.entries(be).filter(([, o]) => typeof o == "number" && o && (i & o) === o).map(([o]) => o.toLowerCase());
    t.dispatchEvent(new CustomEvent("swipe", { detail: a.join("-") })), t.dispatchEvent(new CustomEvent(`swipe${a.join("")}`, { detail: a.join("-") }));
  } }), t.addEventListener("touchstart", Pt), r(() => t.removeEventListener("touchstart", Pt));
}), Pt = (e) => {
  const t = ye.get(e.currentTarget);
  if (!t) return;
  const { clientX: n, clientY: r } = e.touches[0];
  t.start ??= {
    x: n,
    y: r
  }, document.addEventListener("touchend", Ka, { once: !0 });
}, Ka = (e) => {
  const t = e.target;
  if (!t) return;
  const n = ye.get(xn(t, Wa));
  if (!n?.start) return;
  const { clientX: r, clientY: i } = e.changedTouches[0], a = Ga(n.start, {
    x: r,
    y: i
  });
  a !== be.None && (n.dispatch(a), delete n.start);
}, xn = (e, t) => t(e) ? e : e.parentElement ? xn(e.parentElement, t) : null, Ga = (e, t) => {
  const n = [t.x - e.x, t.y - e.y];
  if (n.every((o) => Math.abs(o) < 50)) return be.None;
  const r = Math.sqrt(n[0] * n[0] + n[1] * n[1]), [i, a] = n.map((o) => o / r);
  return jt(i) | jt(a) << 2;
}, jt = (e) => e > 0.5 ? 2 : e < -0.5 ? 1 : 0, Ya = (e) => {
  e.magic("screen", () => (t) => {
    const n = typeof t == "number" ? t : Ja[t] ?? Number(t);
    return n ? Xa(n, e).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(t)})`), !1);
  });
}, Ja = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, En = {}, Xa = (e, t) => En[e] ?? Za(e, t), Za = (e, t) => {
  const n = window.matchMedia(`(min-width: ${e}px)`), r = t.reactive({ value: n.matches });
  return En[e] = r, n.addEventListener("change", (i) => {
    r.value = i.matches;
  }), r;
}, Qa = (e) => e.plugin([Ya]), eo = (e) => e.plugin([
  Ma,
  ja,
  qa,
  za,
  Ua,
  Qa
]), to = (e) => {
  e.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, no = (e) => {
  e.directive("inert-trap", (t, { expression: n, modifiers: r }, { evaluateLater: i, effect: a }) => {
    const o = r.includes("retain"), s = r.includes("noscroll"), c = r.includes("return"), l = i(n), d = [];
    let u = null;
    a(() => {
      l((v) => {
        if (v) {
          u = document.activeElement;
          for (const p of ro(t, ...document.querySelectorAll("[role=alertdialog]"), o ? u?.closest("[data-retain-focus-from]") ?? u : null))
            p.setAttribute("inert", "inert"), d.push(p);
          s && document.documentElement.style.setProperty("overflow", "hidden");
        } else {
          for (const p of d) p.removeAttribute("inert");
          d.length = 0, s && document.documentElement.style.removeProperty("overflow"), c && u && (u.focus(), u = null);
        }
      });
    });
  });
};
function ro(...e) {
  return e = e.filter((t) => t !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (t) => {
    if (!(t instanceof HTMLElement) || t.matches("[inert] > *") || e.includes(t)) return NodeFilter.FILTER_REJECT;
    for (const n of e) if (t.contains(n)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let e = this.nextNode();
  for (; e; )
    yield e, e = this.nextNode();
};
var io = (e) => {
  e.directive("highlight-scroll", (t, { expression: n }, { cleanup: r }) => {
    const i = n.trim();
    if (!i) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const a = t.firstChild;
    if (!a || !(a instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const o = (a.textContent?.trim().split("") ?? []).map((l) => {
      const d = document.createElement("span");
      return d.textContent = l, d.classList.add(i), d;
    });
    a.replaceWith(...o);
    let s = -1;
    const c = setInterval(() => {
      s == -1 ? o.forEach((l) => l.classList.remove(i)) : o[s]?.classList.remove(i), s += 1, s %= o.length, o[s]?.classList.add(i);
    }, 500);
    r(() => clearInterval(c));
  }), e.addInitSelector(() => e.prefixed("highlight-scroll"));
}, ao = [
  ii,
  ia,
  aa,
  oi,
  Mi,
  ca,
  no,
  Vi,
  to,
  Yi,
  na({
    shopify: !0,
    autoSize: !0
  }),
  io,
  Sa,
  ka,
  la,
  eo,
  (e) => {
    e.magic("dataset", (t) => t.dataset), e.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : tt);
  }
], oo = (e) => e.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), so = (e) => e.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), co = [
  Wn,
  oo,
  so,
  kn
];
we.plugin([
  ...ao,
  ...co,
  ...Tr
]);
window.Alpine = we;
var lo = we, po = lo;
export {
  po as default
};
